//Italian
export const language = {
    meassage:{
        leanMore:'Per saperne di più',
        skip:'Salta',
        activate:'Attiva',
        emailSend: 'Email sent!',
        },
leftBanner: {
    liteWebsite: 'Backup del sito web',
    liteClone: 'Clonazione del sito web',
    liteFile: 'Lite File',
    logoSlogan: 'The Go-To Choice for Cloud Transfer',
    cloudEscription: 'MultCloud – La scelta ideale per il trasferimento di dati da cloud a cloud',
    commonTools: 'Strumenti Comuni',
    cloudDrives: 'I Miei Cloud Drive',
    onlineServices: 'I miei servizi online',
    inviteFriends: 'Invita gli amici',
    taskList: 'Elenco delle attività',
    cloudTransfer: 'Trasferimento di Cloud',
    cloudSync: 'Sincronizzazione di Cloud',
    cloudBackup:'Cloud Backup',
    btLink: 'Scarica Offline',
    teamTransfer:'Team Transfer',
    shares: 'Condivisione',
    emailTransfer: 'Trasferire Email',
    instagramDownload: 'Instagram Downloader',
    videoDownload: 'Scaricatore di Video',
    webDownload: 'Scarica immagini',
    addCloud: 'Aggiungi cloud',
    addEmail: 'Aggiungi cloud ed email',
    manageClouds: 'Gestisci cloud ed email',
    manageClouds2: 'Gestisci cloud',
    encryption: 'Crittografia',
    edit: 'Aggiungi di nuovo',
    remove: 'Rimuove',
    createTask: 'Creare Attività',
    createTaskText: 'Puoi creare le attività più comuni qui.',
    gotIt: 'Capito',
    bigWriteEncrypt: 'Crittografia',
    encryptionText: 'Puoi impostare la crittografia dei file nel Cloud qui.',
    addCloudText: 'Clicca qui per connettere il tuo drive cloud e la tua email a MultCloud.',
    switchTxt: 'Passa al classico MultCloud',
    inviteFriends: 'Invita amici',
    switchTip:'Passa a Classico MultCloud',
    switchTipDes:'Puoi passare al classico MultCloud qui.',
    new: 'Nuovo',
},
common: {
    dropFilesToUpload: 'Rilascia i file qui per caricarli nella cartella corrente',
    uploadUnavailable: 'Non è possibile caricare file qui nello stato attuale',
    listView: 'Vista elenco',
    gridView: 'Vista griglia',
    sortBy: 'Ordina per',
    ascending: 'Crescente',
    descending: 'Decrescente',
    addCloud: 'Aggiunge Cloud',
    addEmail: 'Aggiungi Email',
    options: 'Opzioni',
    schedule: 'Pianificazione',
    ok: 'OK',
    save: 'Salva',
    add: 'Aggiunge',
    upgradeNow: 'Aggiorna Ora',
    addWebsite: 'Aggiungi sito web',
    websiteName: 'Nome del sito web',
    websiteTip: 'Fai clic qui per aggiungere il sito web di cui desideri eseguire il backup.',
    continue: 'Continua',
    overwriteTip: 'Se i file o i database del sito di destinazione esistono già, questo ripristino li sovrascriverà. Vuoi continuare?',
    overwriteTip2: 'Se i file o i database del sito di destinazione esistono già, questa clonazione li sovrascriverà. Vuoi continuare?',
    from: 'DA',
    to: 'A',
    result: 'Risultato',
    fileProcess: 'Avanzamento di file',
    transferFiles:'File',
    dataProcess: 'Avanzamento di dati',
    startTime: 'Ora di Inizio',
    currentRate: 'Velocità Attuale',
    endTime: 'Ora di Fine',
    timeRemaining: 'Tempo Rimanente',
    averageRate: 'Velocità Media',
    averageRateSpecial: 'Avg.Rate',
    viewFailed: 'Clic per visualizzare i file non riusciti',
    fileSuccess: 'Trasferimento di tutti i file riuscito',
    size: 'Dimensioine',
    path: 'Percorso',
    setUp: 'Configura',
    backups: 'Backup',
    restoreTo: 'Ripristina in',
    restoreNewLocation: 'Ripristina in una nuova posizione',
    executedTimes: 'Tempi eseguiti',
    sourceDir: 'Directory di Origine',
    cause: 'Cause',
    retry: 'Riprova',
    retryMin: 'Riprova',
    clean: 'Pulisce',
    properties: 'Proprietà',
    copy: 'Copia',
    move: 'Muove',
    multiSelect: 'Scelta Multipla',
    close: 'chiude',
    copyTo: 'Copia su',
    tranTo: 'Trasferisci su',
    syncWith: 'Sincronizza con',
    backupTo: 'Esegui il backup su',
    download: 'Scarica',
    delete: 'Elimina',
    more: 'Altre',
    preview: 'Anteprima',
    share: 'Condivide',
    shareWith: 'Condividi con MultCloud',
    shareTransfer: 'Crea un trasferimento',
    encrypt: 'Crittografa',
    encryptFile: 'Crittografa solo file',
    encryptFileName: 'Crittografa file e nome',
    decrypt: 'Decifra',
    decryptFile: 'Decifra solo file',
    decryptFileName: 'Decifra file e nome',
    onedriveBusinessContentNote: 'Nota',
    oneDrive4BusinessContent: 'Se sei un amministratore e hai assegnato una licenza Microsoft 365 a un utente, ma ricevi un errore di "Accesso negato" quando provi ad accedere alla cartella dell\'utente tramite MultCloud, prova i seguenti passaggi:',
    oneDrive4BusinessTips1: `Vai su "<a href="https://admin.microsoft.com/" target="_blank" class='add-onedrivebuiness-link'>Amministratore</a>". Seleziona "Utenti" > scheda "Attiva Utenti" > Seleziona l\'opzione \'Gestisci Licenza Prodotto\'.`,
    oneDrive4BusinessTips2: 'Vai alla scheda \'OneDrive\' e clicca su \'Crea Link al File\'. Poi, torna a MultCloud e prova ad accedere di nuovo all\'account."',
    oneDrive4BusinessStep1: 'Passo 1',
    oneDrive4BusinessStep2: 'Passo 2',
    upStep: 'Precedente',
    nextStep: 'Successivo',
    complete: 'Finire',
    cut: 'Taglia',
    viewDetails: 'Visualizza Dettagli',
    toOfficialSite: 'Sito Ufficiale',
    btLinkTask: 'Attività Offline',
    fileName: 'Nome di File',
    itemsSelected: 'elementi selezionati',
    dateModified: 'Data di Modifica',
    rename: 'Rinomina',
    paste: 'Incolla',
    btLink: 'Scarica Offline',
    load: 'Caricamento in corso',
    status: 'Stato',
    operate: 'Operazione',
    failure: 'Fallito',
    link: 'Link',
    cleanList: 'Pulire Elenco',
    type: 'Tipo',
    account: 'Account',
    name: 'Nome',
    selectFailedFile: 'Seleziona il file non riuscito',
    transferring: 'Trasferimento in corso',
    newPassword: 'Nuovo Password',
    confirmPassword: 'Conferma Password',
    done: 'Finito',
    no: 'No',
    yes: 'Sì',
    attention: 'Attenzione',
    cancel: 'Cancella',
    unsubscribe: 'Annulla iscrizione',
    reactivate: 'Riattivalo',
    sureCleanAll: 'Sei sicuro di cancellare tutte le attività completate?',
    failedFiles: 'File non riusciti',
    minTo: 'a',
    retryAll: 'Riprova tutto',
    viewProgress: 'Visualizza Progresso',
    taskNotRun: 'Questa attività non è in esecuzione.',
    success: 'Successo',
    canceled: 'Cancellato',
    patial: 'Successo Parziale',
    syncDetails: 'Dettagli di Sincronizzazione',
    width: 'Larghezza',
    sync: 'Sincronizzazione',
    targetCloud: 'Cloud Drive di Destinazione',
    running: 'In esecuzione',
    preparing: 'Sta preparando',
    waiting: 'Sta aspettando',
    target: 'Destinazione',
    noVip: 'Ora puoi solo trasferire un massimo di 2 file simultaneamente. Esegui l\'upgrade a qualsiasi servizio avanzato per trasferire un massimo di 10 file!',
    vipThanks: 'Grazie per aver sottoscritto il nostro servizio. Ora puoi trasferire un massimo di 10 file simultaneamente.',
    emailAccount: 'Email Account',
    with: 'A',
    syncing: 'Sta sincronizzando',
    selectAll: 'Seleziona Tutto',
    date: 'Data',
    failed: 'Fallito',
    skip: 'Salta',
    replace: 'Sostituisce',
    ready: 'Pronto',
    connecting: 'È in connessione',
    account: 'Account',
    selectNull: 'Si prega di selezionare un directory di destinazione.',
    selectOther: 'Questa directory non può essere selezionata per incollare i file, è possibile selezionare le sue sottodirectory o altre directory.',
    //2020-8-18-xth新增
    editShare: 'Modifica Condivisione',
    toSource: 'A Origine',
    copyLink: 'Copia Link',
    toShare: 'Per Condividere',
    report: 'Rapporto',
    expand: 'Estende',
    shrink: 'Riduce',
    // userExpired: 'Le informazioni sull\'utente sono scadute, si prega di aggiornare la pagina'
    //2020-10-26-ljm新增
    filterHolder:'Immettere qui un\'estensione di file, ad esempio mp4',
    countFiles:'Contando archivos',
      //2020-12-2-ljm新增
    upgradeMulti:'Aggiorna a Multithreading',
    team: "File del Team",
    loadData:'Sta caricando i dati, si prega di attendere',
    getAccountInfo:'Non è possibile ottenere le informazioni sull\'account, si prega di eseguire nuovamente l\'accesso e riprovare.',
    loadingData:'Caricamento dei dati...',
    failedEmptyTip: 'Impossibile caricare i file non riusciti. Si prega di contattare <a href="mailto:support@multcloud.com">support@multcloud.com</a> per ulteriore assistenza.',
    runNow:'Esegui ora',
    emailFilter: 'Filtro email',
    me: "Io",
    reset: "Ripristina",
    apply: "Applica",
    failureReason: 'Motivo dell\'errore',
    countingFilesTip: 'Calcolo in corso ({num} file)',
    taskName: 'Nome attività',
    frequency: 'Frequenza:',
    canceling: 'Annullamento in corso...',
},
rightTopBanner: {
    navTransfer: 'Trasferimento da Cloud a Cloud',
    navInstagram: 'Instagram Downloader',
    navVideo: 'Scaricatore di Video',
    navWeb: 'Scarica immagini',
    traffic: 'Traffico',
    upgrade: 'Aggiorna',
    settings: 'Impostazioni',
    changePassword: 'Modifica Password',
    changeName: 'Cambia Nome',
    bindEmail: 'Associa Email',
    deleteAccount: 'Elimina Account',
    language: 'Lingua',
    help: 'Aiuto',
    notifications: 'Notifiche',
    notification: 'Aggiornamenti',
    subAccounts: 'Account secondari',
    logout: 'Logout',
    tutorials: 'Tutorial',
    contact: 'Contatto',
    limitsClouds: 'Limiti di Cloud',
    faq: 'FAQ',
    purTraffic: 'Acquista Traffico',
    unlimitedPlan: 'Piano Illimitato',
    monthlyUnlimitedPlan: 'Piano Illimitato Mensile',
    rememberOriginal: 'Ricorda il tuo nome utente originale:',
    andPassword: 'e password',
    bindEmailOpen: 'Meglio <span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen"> associare il tuo indirizzo email e cambiare la password predefinita</span> per sicurezza e comodità.',
    lifeSwitchTip: 'Con il servizio IllIMITATO A VITA, puoi trasferire i file tra Cloud senza limiti di traffico.',
    lifeTimePlan: 'Illimitato a vita',
    browserPrompt:'Per avere una migliore esperienza utente, suggeriamo di utilizzare Google Chrome.',
    unlimited:'Illimitato',
    lifeTimeNotice:'Sei un utente di MultCloud Piano Illimitato a Vita.',
    subAccount:"Sottoconto",
    bindMailTips:"Collega la tua e-mail per sbloccare il trasferimento di file cloud e sfruttare appieno MultCloud.",
    bind: "Lega",
},
liteApp: {
    menu: 'Le mie app',
    title: 'Le mie app',
    edit: 'Modifica',
    warning: 'Avviso',
    description: 'Gestisci le applicazioni OAuth utilizzate per connettere i servizi cloud.',
    addApp: 'Aggiungi app',
    empty: 'Non hai ancora aggiunto app personalizzate.',
    appType: 'Servizio cloud',
    appName: 'Nome dell’app',
    clientId: 'ID client / chiave dell’app',
    clientSecret: 'Segreto client / segreto dell’app',
    callback: 'URI di reindirizzamento',
    secretUnchanged: 'Lascia vuoto per non modificare',
    inUse: 'In uso',
    usedTip: 'Questa app è usata da una o più unità cloud. Le sue credenziali non possono essere modificate.',
    nameRequired: 'Inserisci un nome per l’app.',
    credentialsRequired: 'Inserisci ID client e segreto client.',
    secretRequiredForKey: 'Inserisci il segreto client quando modifichi l’ID client.',
    deleteConfirm: 'Eliminare questa app personalizzata? Prima devi rimuovere le unità cloud che la usano.',
    appInUse: 'Questa app è usata da un’unità cloud e non può essere eliminata né può modificarne le credenziali.',
    nameExists: 'Esiste già un’app con questo nome per questo servizio cloud.',
    systemAppUnavailable: 'L’app predefinita di MultCloud non è disponibile per questo servizio cloud.',
    selectApp: 'App',
    defaultApp: 'Usa l’app predefinita di MultCloud',
    selectAppTip: 'Scegli l’app utilizzata per autorizzare questo servizio cloud.',
    copySuccess: 'Copiato negli appunti',
},
popup: {
    userStarPopup: {
        starDesc: "Si prega di valutare MultCloud!",
        ok: "OK",
        thankYou: "Grazie",
        thankYouDesc: "Se volessi prenderti un momento per condividere la tua esperienza reale e onesta utilizzando il nostro prodotto, ci aiuterebbe a migliorare ancora di più MultCloud.",
        reviewStart: "Scrivici una recensione su",
        reviewEnd: "",
        feedbackTitle: "Come possiamo migliorare?",
        feedbackDesc: "Aggiungi il tuo feedback",
        feedbackBtn: "Invia",
        feedbackYes: "Grazie per il feedback.",
        feedbackNo: "Descrivi il tuo feedback.",
    },
    addCloudPopup: {
        endpointOptional:'Punto finale (opzionale)',
        regionOptional: 'Regione (facoltativo)',
        bucketOptional: 'Bucket (facoltativo)',
        //2020.09.23 添加NAS云盘
        addNas: 'AGGIUNGE NAS',
        addNasFtpDes: ` Connetti il NAS tramite FTP. Non sai come configurare FTP per NAS?

Si prega di <a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>fare clic qui</a>`,
        addNasWebDes: `Connetti il NAS tramite WebDAV. Non sai come configurare WebDAV per NAS?
Si prega di <a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>fare clic qui</a>`,
        //
        bucketName: 'Nome Bucket',
        accessKeyId: 'ID Chiave di Accesso',
        idriveKeyId: 'Access Key ID',
        secretAccessKey: 'Chiave di Accesso Segreta',
        idriveSecretAccessKey: 'Secret Access Key',
        endpoint: 'Endpoint',
        displayName: 'Nome di Visualizzazione',
        addFtp: 'AGGIUNGE FTP',
        addFtpDes: 'Per connettere il tuo FTP, MultCloud ti richiede di inserire i tuoi dettagli di autenticazione.',
        egnyteTip: `Suggerimenti: per ottenere la chiave e il segreto, avrai bisogno dell'ID di gestione API Egnyte. Se non ne hai uno, puoi <a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>registrarti</a>.`,
        icedriveTip: 'Nota:',
        icedriveTip1: '1. Supporta solo account Premium di Icedrive.',
        icedriveTip2:`2. fai clic sul nome utente Icedrive -> 2FA e accesso -> WebDAV -> Abilita -> Mostra chiave. La chiave di accesso è la password.`,
        iCloudPhotosTip: 'Suggerimenti:',
        iCloudPhotosTip1: '1. Prima di collegare le tue Foto iCloud a MultCloud, assicurati che "Accesso ai dati di iCloud sul web" sia attivato.',
        iCloudPhotosTip1Q: `Come gestire l'accesso web ai tuoi dati iCloud:<br><br>Su iPhone o iPad<br>1. Apri l'app Impostazioni.<br>2. Tocca il tuo nome, poi tocca iCloud.<br><br>3. Tocca per disattivare o attivare l'Accesso ai dati di iCloud sul web.<br>
        <br>Su Mac<br>1. Scegli il menu Apple > Preferenze di Sistema.<br>2. Fai clic sul tuo nome, poi fai clic su iCloud.<br>3. Fai clic per disattivare o attivare l'Accesso ai dati di iCloud sul web.`,
        iCloudPhotosTip2: '2. Le Foto iCloud supportano solo i seguenti formati di immagine: jfif, pjpeg, jpeg, pjp, jpg, HEIC.',
        iCloudGuideIntro: "Per aggiungere {cloud} a MultCloud, verifica quanto segue:",
        iCloudAuthCountry: "Paese/Regione",
        iCloudAuthCountryDefault: "Predefinito",
        iCloudAuthCountries: {
            US: "Stati Uniti",
            DE: "Germania",
            FR: "Francia",
            JP: "Giappone",
            PT: "Portogallo",
            IT: "Italia",
            NL: "Paesi Bassi",
            ES: "Spagna",
        },
        iCloudGuideStep1: `1. “Accesso ai dati di iCloud sul web” è attivato.`,
        iCloudGuideIOS: `Su iPhone o iPad:`,
        iCloudGuideIOSInstructions: `Vai a Impostazioni > [il tuo nome] > iCloud > iCloud.com, quindi attiva “Consenti accesso ai dati”.`,
        iCloudGuideMac: `Su Mac:`,
        iCloudGuideMacInstructions: `Vai al menu Apple > Impostazioni di Sistema > [il tuo nome] > iCloud > Accesso ai dati su iCloud.com, quindi attiva “Consenti accesso ai dati”.`,
        iCloudGuideStep2: `2. Assicurati che il dispositivo che riceve il codice di verifica abbia effettuato l’accesso all’Apple Account corretto.`,
        iCloudGuideStep2Instructions: `Durante l’autorizzazione, Apple invia un codice di verifica a un dispositivo che ha effettuato l’accesso all’Apple Account che desideri collegare a MultCloud. Assicurati che il dispositivo utilizzato per ricevere il codice abbia effettuato l’accesso allo stesso account.`,
        iCloudPhotosGuideFormats: `Suggerimento: Foto di iCloud supporta solo i seguenti formati di immagine: jfif, pjpeg, jpeg, pjp, jpg, HEIC.`,
        iCloudGuideViewImage: `Visualizza l’immagine del tutorial ingrandita`,
        iCloudGuideImageAlt: `Configurazione di {cloud}, passaggio {step}`,
        iCloudDomainTip: 'Se il tuo account iCloud appartiene alla regione Cina, assicurati di selezionare www.icloud.com.cn nel campo Dominio.',
        googleDrive2FATip: 'Suggerimenti per l\'autenticazione a 2 fattori di Google Drive',
        googleDrive2FATip1: 'Assicurati di selezionare "Visualizza, modifica, crea ed elimina tutti i tuoi file Google Drive" nella pagina di autorizzazione di Google Drive.',
        server: 'server',
        protocol: 'Protocollo',
        port: 'Porta',
        passive: 'Modalità passiva',
        passphrase: 'Frase segreta',
        explanation: ' Per connettere a FTP, il prefisso deve essere "ftp://" o il prefisso è mancato.Se la tua porta FTP non è predefinita, è un numero di porta speciale, come 21, si prega di utilizzare il formato per specificare la porta di seguito:ftp://ftp.myhost.com:21',
        userName: 'Nome utente',
        passWord: 'Password',
        advanced: 'Avanzato',
        commFTP: 'FTP Comune',
        transMode: 'Modalità di trasferimento',
        encoding: 'Codifica',
        path: 'Percorso(opzionale)',
        cloudName: 'Nome Cloud',
        cloudService: 'Servizio Cloud',
        addedTime: 'Tempo Aggiunto',
        usedSpace: 'Spazio Usato',
        totalSpace: 'Spazio Totale',
        iCloudUsedSpace: 'Archiviazione di foto di iCloud',
        iCloudDriveUsedSpace: 'Archiviazione di iCloud Drive',
        iCloudTotalSpace: 'Archiviazione totale iCloud',
        iCloudDriveTotalSpace: 'Archiviazione totale iCloud',
        removeContent: 'Alcune attività di trasferimento nel Cloud si basano su questo Cloud. Vuoi ancora rimuoverlo?',
        baiDuTips: 'A causa delle limitazioni di Baidu Cloud, i file/cartelle possono essere trasferiti solo in "Tutti i file/I miei dati dell\'applicazione/Multcloud".',
        google_driveTips: 'Quando trasferisci i file o le cartelle da Google Drive ad altri, assicurati che non ci siano i file con stessi nomi nella stessa directory.',
        mySQLQuestion: 'Devi inserire il tuo indirizzo IP del server MySQL nel campo del server e la porta predefinita è 3306, oppure devi inserire la tua porta personalizzata.',
        webDavQuestion: `Se utilizzi una connessione SSL sicura, aggiungi il prefisso "https://" al tuo host o non fare nulla e la porta predefinita è 443, altrimenti il prefisso dovrebbe essere "http://" e la porta predefinita è 80. ad es. https://dav.box.com/dav`,
egnyteQuestion: 'Accedi a Engnyte e trovi il tuo dominio nella barra degli indirizzi. Inserisci il dominio in questo formato: ad es. https://aomeitech.egnyte.com/',
        ownCloudQuestion: 'Se utilizzi una connessione SSL sicura, aggiungi il prefisso "https://" al tuo host o non fare nulla e la porta predefinita è 443, altrimenti il prefisso dovrebbe essere "http://" e la porta predefinita è 80',
        amazonQuestion: `Visiti la pagina per scoprire <a href="https://www.multcloud.com/tutorials/s3- key.html" target="_blank" class='add-cloud-link'> come ottenere ID della chiave di accesso Amazon S3.</a>`,
        boxTips: `Box non supporta la trasmissione di un singolo file di dimensioni superiori a 2 GB.`,
        google_drive_sharedWithMeTips:'Quando trasferisci i file nelle cartelle di Shared With Me drive, assicurati di essere autorizzato con il "Permesso di caricamento".',
                   gSuiteSharedDriveTips:'Quando trasferisci i file nelle cartelle di Shared Drive, assicurati di essere autorizzato con "Permesso di caricamento".',
        webDavTips: `1. Assicurati di avere i permessi di lettura/scrittura prima delle operazioni sui file, altrimenti MultCloud potrebbe non essere in grado di trasferire i file nel tuo WebDav.
        2. Assicurati che ci sia spazio sufficiente per le tue operazioni. Non siamo temporaneamente in grado di identificarne le dimensioni.`,
        aDriveTips: 'Attualmente supportiamo l\’account Personale Avanzata e l\’account Aziendale, ma non supporta l\’account Personale Basico al momento.',
        yandexTips: `1.Assicurati che ci sia spazio sufficiente per le tue operazioni. Non siamo temporaneamente in grado di identificarne le dimensioni.
                     2.Se hai abilitato la password dell'app, inserisci la password dell'app nella barra di password in alto.`,
        googlePhotosTips: `1. La directory "Foto" può memorizzare solo immagini, video e altri file multimediali, ma non directory.
        2. La directory "Album" può memorizzare solo directory di album, ma non file multimediali.
        3. La directory "Condivisione" contiene tutti gli album condivisi da te o gli album condivisi a cui ti sei unito.
        4.Google Foto supporta solo il caricamento di immagini, video e altri file multimediali. E quando si utilizza la funzione di caricamento MultCloud, è possibile caricare file solo nelle directory degli album create o condivise da MultCloud.
        5. Quando si utilizza la funzione di condivisione della sorgente MultCloud, è possibile condividere solo gli album creati da MultCloud.
        6. Tutti gli album senza titolo verranno visualizzati come "Senza titolo".
        7. Al momento, la funzione di download è disponibile, ma il download dei file originali non è supportato.
        8. Al momento, non supporta le operazioni di taglio, eliminazione e ridenominazione. E non è possibile utilizzare le funzioni che si basano su queste operazioni.`,
        googlePhotosV2Tips: `1. La directory "Foto" può memorizzare solo immagini, video e altri file multimediali, ma non directory.
        2. La directory "Album" può memorizzare solo directory di album, ma non file multimediali.`,
        evernoteTips: `1. Limiti di velocità API. <a href='https://dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'> Visualizza dettagli>> </a>
          2. Quali sono i limiti di sistema di Evernote? <a href='https://help.evernote.com/hc/en-us/articles/209005247-What-are-the-system-limits-of-Evernote-' target="_blank" class='add-cloud-link'> Visualizza dettagli >></a>
          3. Puoi caricare nella nota solo un file di dimensioni inferiori a 50 MB.
          4. Impossibile rinominare o eliminare i file di contenuto delle note (. ENML).
          5. Può solo copiare le note sul taccuino.`,
        flickrTips: `1. È possibile trasferire solo immagini o video su Flickr.
        2. Le cartelle possono essere trasferite solo nella directory "Album" e non possono esserci sottodirectory nella directory "Album".
        3. I file possono essere trasferiti solo nella directory "Fotografia" o "Album" creata.
        4. Tutti i tuoi file possono essere trovati nella directory "Fotografia".
        5. Tutti i file nella directory "Album" fanno riferimento alla directory "Fotografia".`,
        mediafireTips: 'Carica e scarica i file vuoti non sono supportati. È possibile richiedere molto tempo per aprire una cartella che contiene molti file.',
        mySQLTips: `1. Il tuo database deve essere accessibile dai nostri indirizzi IP, che sono 209.126.%. È possibile creare un nuovo utente tramite il database o l\'interfaccia host, il comando MySQL è il seguente:
        <span class='add-mysql-link'>GRANT SHOW DATABASES, SELECT, LOCK TABLES, RELOAD ON *.* TO username@'209.126.%' IDENTIFIED BY 'password';</span>
        2. Potrebbe essere necessario aggiungere una regola firewall con i nostri indirizzi IP e la porta di accesso (la porta predefinita è 3306) al tuo server per accedere normalmente ai tuoi database.`,
        hubiCTips: `1. Un account hubiC può aggiungere solo una volta.
        2. Non è possibile rinominare e tagliare i file o le cartelle.
        3. Potrebbe essere un po\' lento eliminare le cartelle con molti file.
        4. hubiC non supporta la trasmissione di un singolo file superiore a 5 GB.
        5. I nomi dei file non possono superare i 248 caratteri e i nomi delle cartelle sono limitati a 256 caratteri.`,
        gSuiteUpTips: `La connessione tra G Suite e MultCloud è disponibile solo per gli amministratori di G Suite. Per connettere G Suite a MultCloud, devi "INSTALLARE DOMINIO" il nostro G Suite Marketplace app --- <a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud?hl=en' target="_blank" class='add-cloud-link'>"Cloud Transfer - MultCloud"</a> primamente.`,
        gSuiteTips: `1. Devi essere un <a href="https://support.google.com/a/answer/2405986?hl=en" target="_blank" class='add-cloud-link'> amministratore di G Suite </a>.
                    2. Come verificare se sarebbe un account amministratore? Per prima cosa, fa riferimento a questo link <a href='https://support.google.com/a/answer/2406043' target="_blank" class='add-cloud-link'> https://support.google.com/a/answer/2406043</a>. In secondo, accedi al tuo account G Suite dal link. Terzo, puoi trovare i risultati nella riga "Per creare un ruolo personalizzato".
                    3.<a href='https://support.google.com/a/answer/60757?hl=en' target="_blank" class='add-cloud-link'> L\'accesso API </a>è abilitato.
                    4. Prima di aggiungere questo cloud drive, è necessario installare prima la nostra <a href='https://gsuite.google.com/marketplace?hl=en' target="_blank"  class='add-cloud-link'> G Suite Marketplace app </a> "MultCloud for G Suite" e assicurarsi che la sua <a href='https://admin.google.com/' target="_blank" class='add-cloud-link'>configurazione </a> sia corretta: lo stato è attivo e l\'accesso ai dati è concesso.`,
        google_workspaceTips: `1. La directory principale di Google Workspace e la directory di ogni membro servono solo per esplorare membri e categorie. Non puoi caricare file o creare cartelle al loro interno.
        2. My Drive (Google Drive Root): questa è la directory principale di Google Drive personale del membro. Le operazioni disponibili dipendono dalle autorizzazioni Google Drive del membro.
        3. Shared drives: le operazioni disponibili dipendono dal ruolo del membro nell'unità condivisa e dalle autorizzazioni della cartella.
        4. Shared with me: questo è un elenco di elementi condivisi con il membro, non una cartella fisica. Non puoi caricare file o creare cartelle direttamente qui. All'interno di una cartella condivisa, il caricamento e la creazione di cartelle sono disponibili solo con l'autorizzazione Editor; gli utenti con ruolo Visualizzatore o Commentatore dispongono solo dell'accesso in lettura.`,
        hiDriveTips: `1. Assicurati di avere un account con il protocollo WebDAV abilitato e autorizzazioni di lettura/scrittura prima di lavorare con i file, altrimenti MultCloud potrebbe non essere in grado di trasferire file sul tuo HiDrive.
        2. Assicurati che ci sia spazio sufficiente per le tue operazioni. Non siamo temporaneamente in grado di identificarne le dimensioni.`,
        backblazeTips: `1. Ogni nome di bucket deve contenere almeno 6 caratteri.
        2. Quando crei una nuova chiave dell\'applicazione, quella vecchia non funzionerà più.
        3. I nomi dei file non possono iniziare con "/", finire con "/" o contenere "//".`,
        WEBDETips: `1. Assicurati di avere i permessi di lettura/scrittura prima delle operazioni sui file, altrimenti MultCloud potrebbe non essere in grado di trasferire i file al tuo Web.De.
        2. Assicurati che ci sia spazio sufficiente per le tue operazioni. Non siamo temporaneamente in grado di identificarne le dimensioni.`,
        alfrescoTips: `Essendo un account Alfresco gratuito, il tuo spazio di archiviazione per la rete è di 10 GB e il limite delle dimensioni dei singoli file è di 50 MB.`,
        cloudMeTips: `1. Assicurati di avere i permessi di lettura/scrittura prima delle operazioni sui file, altrimenti MultCloud potrebbe non essere in grado di trasferire i file al tuo CloudMe.
        2. Assicurati che ci sia spazio sufficiente per le tue operazioni. Non siamo temporaneamente in grado di identificarne le dimensioni.`,
        myDriveTips: `Assicurati che ci sia spazio sufficiente per le tue operazioni. Non siamo temporaneamente in grado di identificarne le dimensioni.`,
        cubbyTips: `1. Assicurati di avere i permessi di lettura/scrittura prima delle operazioni sui file, altrimenti MultCloud potrebbe non essere in grado di trasferire i file al tuo Cubby.
        2. Assicurati che ci sia spazio sufficiente per le tue operazioni. Non siamo temporaneamente in grado di identificarne le dimensioni.`,
        cloudType: 'Tipo di Cloud',
        notificationTip: ` Grazie per aver utilizzato l\'ultimo MultCloud, in caso di problemi, si prega di contattarci: <a href="mailto:support@multcloud.com">support@multcloud.com</a>, grazie.`,
        notAbleAccess: 'Problema Risolto - Impossibile accedere a Google Foto',
        problemNotAccess: 'Il problema Impossibile Accedere a Google Foto è stato risolto. Se non riesci ancora ad accedere a Google Foto, aggiungilo di nuovo a MultCloud.',
        noPrompt: 'Non chiedere di più la prossima volta',
        addFeatures: ' Alcune nuove funzioni aggiunte di seguito:',
        version: 'Versione:',
        releasedOn: 'Rilasciato il ',
        newLabel: 'Nuovo :',
        improvedLabel: 'Migliorato :',
        noteLabel: 'Nota :',
        tryNewFeatures: 'Prova subito queste nuove funzionalità e migliora la tua esperienza di gestione dei file con MultCloud!',
        okButton: 'OK',
        notif_v885: `Backup del sito: esegui il backup di file o database del sito sul cloud e ripristinali quando necessario. Clonazione del sito: copia facilmente file o database su un altro sito.`,
        notif_v884: `Aumentata l’altezza dell’elenco cloud per gestire più account con maggiore facilità.`,
        notif_v881: `Autorizzazione iCloud migliorata con codici di verifica del dispositivo; MultCloud Plus ottimizzato e accesso rapido Facebook ripristinato.`,
        notif_v880: `Introdotto MultCloud Plus: trasferimenti cloud e servizi selezionati in un’esperienza più leggera, con maggiore successo.`,
        notif_v870: `I file non supportati di Dropbox Paper e Google Drive sono esclusi; migliorata la percentuale SFTP e risolto il blocco delle attività temporanee.`,
        notif_v831: `Risolti i casi di attività temporanee fallite visualizzate come riuscite e trasferimenti bloccati in attesa.`,
        notif_v830: `Risolto il problema delle attività pianificate non eseguite in tempo; aggiunta l’attivazione tramite codice.`,
        notif_v780: `Aggiunti strumenti Web per scaricare video e Instagram senza installazione; percentuale FTP migliorata.`,
        notif_v760: `Le date originali dei file vengono mantenute dopo la sincronizzazione.`,
        notif_v750: `Migliorata la percentuale dei trasferimenti Google Foto.`,
        notif_v740: `<b>Downloader di video online</b>
<div>Scarica video di alta qualità da YouTube, Facebook, X, TikTok e oltre 1000 altri siti con il Downloader di video online senza pubblicità e multipiattaforma di MultCloud, senza necessità di installazione.</div>
<b>Prova subito queste nuove funzionalità e migliora la tua esperienza di gestione dei file con MultCloud!</b>`,
        notif_v730: `<b>Downloader di immagini web</b>
<div>Raccogli facilmente immagini da qualsiasi sito web o ricerca Google inserendo un URL o una parola chiave e salvale direttamente nel tuo cloud storage o sul tuo dispositivo locale.</div>
<b>Prova subito queste nuove funzionalità e migliora la tua esperienza di gestione dei file con MultCloud!</b>`,
        notif_v720: `<div>Siamo lieti di annunciare nuove funzionalità e miglioramenti in MultCloud:</div>
<ol class="imagesaver_versions">
<li><b>Instagram Downloader:</b><div>Ora puoi scaricare facilmente i contenuti di Instagram! Con il nuovo Instagram Downloader, gli utenti possono scaricare o caricare immagini del profilo, post, Reels, Storie e Highlights di Instagram direttamente nel cloud storage o sul dispositivo locale.</div></li>
<li><div>Le funzionalità Video Downloader e Image Downloader saranno disponibili presto.</div></li>
</ol>`,
        notif_v710: `<div>Siamo lieti di presentare la nuova funzione Image Saver in MultCloud! Ecco i dettagli delle nuove funzionalità:</div>
<ol class="imagesaver_versions">
<li><b>Salva immagini e video di Instagram</b>
<ul class="imagesaver_version">
<li type="disc"><b>Supporto di più link: </b>Salva immagini e video da 1-3 link Instagram contemporaneamente.</li>
<li type="disc"><b>Caricamento e download facili: </b>Scegli di caricare i media direttamente nel tuo cloud storage o di scaricarli sul dispositivo locale.</li>
</ul></li>
<li><b>Salva immagini di siti web</b>
<ul class="imagesaver_version">
<li type="disc"><b>Supporto di più link: </b>Salva immagini da 1-3 link di siti web contemporaneamente.</li>
<li type="disc"><b>Opzioni di archiviazione flessibili: </b>Carica le immagini direttamente nel tuo cloud storage preferito o scaricale localmente.</li>
</ul></li>
<li><b>Salva immagini della ricerca Google</b>
<ul class="imagesaver_version">
<li type="disc"><b>Ricerca per parola chiave: </b>Inserisci una parola chiave per cercare immagini su Google.</li>
<li type="disc"><b>Salvataggio diretto: </b>Carica facilmente i risultati della ricerca nel tuo cloud storage o scaricali sul tuo computer.</li>
</ul></li>
</ol>`,
        notif_v700: `<div>MultCloud ora supporta 4shared e lDrive e2.</div>`,
        notif_v630: `<div>MultCloud ora supporta Icedrive.</div>`,
        notif_v620: `<div>Estensioni Chrome: MultCloud Save - Salva pagina web come PDF.</div>`,
        notif_v550: `<div>MultCloud ora supporta Outlook.</div>`,
        notif_v530: `<div>MultCloud ora supporta iCloud Drive.</div>`,
        notif_v520: `<div>MultCloud ora supporta Gmail.</div>`,
        notif_v500: `<div>MultCloud ora supporta iCloud Photos.</div>`,
        notif_v490: `<div>Correzioni di bug su backup e ripristino cloud.</div>`,
        notif_v487: `<div>Supportato lo storage online SharePoint.</div>`,
        notif_v485: `<div>Trasferimento di condivisione.</div>
<div>Con questa funzione puoi consegnare facilmente file di grandi dimensioni a chiunque.</div>
<b>Guida rapida :</b>
<div>1.Fai clic con il tasto destro sul file che desideri inviare (per selezionare il file, aggiungi prima a MultCloud il cloud in cui si trova il file).</div>
<div>2.Vai su "Condividi" e seleziona "Crea un trasferimento".</div>`,
        notif_v482: `<div>Aggiunto Wasabi Cloud.</div>
<div>Gli utenti Wasabi ora possono collegare Wasabi a MultCloud.</div>`,
        notif_v480: `<div>Trasferimento di gruppo.</div>
<div>Migra facilmente i cloud aziendali da un tenant a un altro. Sono supportati Google Workspace (e Shared Drive), OneDrive for Business, Dropbox Business, Box for Business.</div>`,
        notif_v470: `<div>Aggiunta la funzione di backup e ripristino tra cloud.</div>`,
        notif_v468: `<div>Tutti i cloud sono supportati per la sincronizzazione in tempo reale.</div>
<b>Migliorato :</b>
<div>Interfaccia migliorata nella pagina di condivisione.</div>`,
        notif_v467: `<div>Le attività di sincronizzazione tra cloud ora supportano la sincronizzazione in tempo reale.</div>
<b>Migliorato :</b>
<div>Miglioramenti di velocità per le nuove attività di trasferimento e sincronizzazione.</div>`,
        notif_v465: `<div>1.Rilasciata nuova interfaccia.</div>
<div>2.Supportato il caricamento di torrent nel cloud.</div>`,
        notif_v457: `<div>1.Aggiunto NAS.</div>`,
        notif_v456: `<div>1.Risolto il problema di impossibilità di accesso a Google Foto.</div>`,
        notif_v455: `<div>1.Migliorata la funzione di condivisione di MultCloud per traffico gratuito.</div>`,
        notif_v454: `<div>1.Aggiunta la funzione di trasferimento da più origini.</div>
<div>2.Aggiunta la crittografia e decrittografia file online.</div>
<div>3.Aggiunta l'opzione di crittografia del nome file alla funzione di crittografia file.</div>`,
        notif_v453: `<div>1.Ottimizzato il cloud Dropbox for Business.</div>`,
        notif_v452: `<div>1.Nuova funzione premium: crittografia del caricamento file.</div>`,
        notif_v451: `<div>1.Miglioramenti al server di trasporto di MultCloud.</div>
<div>2.Aggiornati i piani gratuito e premium.</div>`,
        notif_v450: `<div>1.Aggiunto cestino per alcuni cloud.</div>
<div>2.Modificate alcune interfacce del nostro sito web.</div>
<div>3.Ottimizzate alcune funzioni.</div>`,
        notif_v444: `<div>1.Aggiunti Google Photos e Put.io.</div>`,
        notif_v443: `<div>1.Aggiunta la funzione di sincronizzazione unidirezionale multi-destinazione.</div>`,
        notif_v442: `<div>1.Aggiunto Backblaze.</div>`,
        notif_v441: `<div>1.Aggiunto Google Drive per G Suite.</div>`,
        notif_v440: `<div>1.Aggiunta la gestione dei sotto-account.</div>
<div>2.Migliorato il cloud drive Google.</div>
<div>3.Corretti alcuni bug dei cloud drive.</div>`,
        notif_v431: `<div>1.Migliorata la funzione di autorizzazione di OneDrive for Business e risolto il problema per cui alcuni utenti non potevano aggiungere questo cloud.</div>
<b>Nota :</b>
<div>Si prega di aggiungere nuovamente il cloud OneDrive for Business e le attività di trasferimento per gli utenti che hanno aggiunto questo cloud, ci scusiamo per l'inconveniente.</div>`,
        notif_v430: `<div>1.Aggiunto il supporto per il drive pCloud.</div>
<div>2.Corretti alcuni bug dei cloud drive.</div>`,
        notif_v420: `<div>1.Aggiunti tedesco e cinese tradizionale al multilingua.</div>
<div>2.Migliorato il cloud drive Dropbox.</div>
<div>3.Migliorata la funzione di condivisione e aggiunte azioni di caricamento e nuova cartella nella pagina di condivisione.</div>`,
        notif_v410: `<div>1.Aggiunto sistema di punti.</div>
<div>2.Aggiunta la funzione di visualizzazione errori storico.</div>
<div>3.Aggiunto il pulsante di nuovo tentativo manuale quando il trasferimento fallisce.</div>
<div>4.Migliorate le funzioni di ricerca, condivisione e avanzamento del trasferimento.</div>`,
        notif_v400: `<div>1.Aggiunta la funzione di sincronizzazione cloud, inclusa la sincronizzazione unidirezionale, bidirezionale e altro.</div>
<div>2.Aggiunto il supporto per i cloud drive OneDrive for Business, Dropbox for Business ed Egnyte.</div>
<div>3.Migliorata la funzione di condivisione.</div>
<div>4.Migliorata l'interfaccia utente.</div>
<div>5.Corretti bug del trasferimento.</div>`,
        notif_v380: `<div>1.Aggiornata la funzione di condivisione, aggiunte funzioni di condivisione cartelle, gestione condivisioni, salvataggio condivisioni e trasferimento condivisioni.</div>
<div>2.Aggiunta l'opzione "URL di caricamento" nella funzione di caricamento.</div>
<div>3.Corretti alcuni bug dei cloud drive.</div>
<div>4.Rimosso il cloud drive Copy.</div>`,
        notif_v370: `<div>1.Aggiunti i cloud drive Mega ed Evernote.</div>
<div>2.Aggiunto il supporto di anteprima dei file di testo, come txt, html, js.</div>
<div>3.Ottimizzate le attività pianificate.</div>
<div>4.Corretto il bug del trasferimento di documenti Google tra Google Drive per mantenere i tipi di file coerenti.</div>
<div>5.Amazon S3 supporta il trasferimento di un singolo file superiore a 5 GB.</div>`,
        notif_v360: `<div>1.Aggiunto il cloud drive hubiC.</div>
<div>2.Aggiunta la funzione "Prova senza registrarti" per un'esperienza rapida.</div>
<div>3.Aggiunta la funzione "Vai al sito ufficiale" per alcuni cloud drive.</div>
<div>4.Corretti bug di trasmissione di OneDrive e Google Drive.</div>`,
        notif_v350: `<div>1.Migliorata la velocità di trasmissione tra cloud per gli utenti VIP.</div>
<div>2.Aggiunti backup MySQL e il cloud drive Flickr.</div>
<div>3.Corretti alcuni bug del trasferimento pianificato.</div>
<div>4.Corretto il bug che non permetteva di elencare i file di FTP e WebDav.</div>`,
        notif_v340: `<div>1.Aggiunto MediaFire a MultCloud.</div>
<div>2.Aggiunto OwnCloud a MultCloud.</div>
<div>3.Modificato il trasferimento file pianificato.</div>`,
        notif_v330: `<div>1.Aggiunto Alfreco a MultCloud.</div>
<div>2.Aggiunto aDrive a MultCloud.</div>
<div>3.Modificata l'eccezione di interruzione per la trasmissione tra cloud diversi.</div>`,
        notif_v320: `<div>1.Aggiunta l'opzione "sostituzione".</div>
<div>2.Aggiornata l'API di OneDrive e rimossi alcuni limiti.</div>
<div>3.Corretto il bug del cloud drive Amazon.</div>
<div>4.Ottimizzato l'ambiente di trasmissione.</div>`,
        notif_v310: `<div>1.Supportato il cloud drive Amazon.</div>
<div>2.Supportata la sostituzione o l'omissione di alcuni file durante il trasferimento.</div>
<div>3.Potenziato il servizio SFTP: supportato l'accesso con chiave privata.</div>
<div>4.Ottimizzata la funzione di trasferimento.</div>
<div>5.Corretti alcuni bug dei cloud drive.</div>`,
        notif_v300: `<div>1.Aggiunte nuove funzioni come Trasferimento e Gestione attività.</div>
<div>2.Supportata l'impostazione di trasferimento pianificato e filtro file.</div>
<div>3.Supportata la notifica automatica via email dopo il trasferimento.</div>
<div>4.Supportata la modifica degli account e la visualizzazione delle proprietà dei cloud drive.</div>
<div>5.Regolate e ottimizzate alcune interfacce utente.</div>
<div>6.Migliorata la stabilità e la velocità del trasferimento ottimizzando l'ambiente di rete.</div>
<div>7.Corretti alcuni bug.</div>`,
        notif_v231: `<div>1.Rimosso il pulsante "in background" e tutte le attività di trasmissione saranno impostate in background per impostazione predefinita.</div>
<div>2.Corretti alcuni bug.</div>`,
        notif_v230: `<div>1.Aggiunta la funzione di trasmissione in background.</div>
<div>2.Migliorata la capacità di trasmissione.</div>
<div>3.Aggiunta la funzione di visualizzazione delle dimensioni dei cloud drive.</div>`,
        notif_v222: `<div>1.Aggiunta la funzione di visualizzazione del menu contestuale per tablet e dispositivi mobili.</div>
<div>2.Modificate le eccezioni relative a registrazione e recupero password. Consente inoltre di saltare l'attivazione per utilizzare MultCloud.</div>
<div>3.Modificata l'eccezione che non permetteva di aggiungere l'indirizzo del server che inizia con http per WebDav.</div>`,
        notif_v221: `<div>1.Modificate le eccezioni relative a elenco, ricerca e copia di file di Google Drive.</div>`,
        notif_v220: `<div>1.Modificate le eccezioni di trasmissione in blocco per una maggiore stabilità di trasmissione.</div>
<div>2.Aggiunta la funzione di scansione dei dettagli di avanzamento della trasmissione.</div>`,
        notif_v210: `<div>1.Modificato il problema della visualizzazione incompleta degli elenchi di file.</div>
<div>2.Modificate le eccezioni relative a caricamento, download e trasmissione di file in FTP.</div>
<div>3.Modificata l'eccezione di interruzione per la trasmissione tra cloud diversi.</div>
<div>4.Modificata l'interfaccia utente di aggiunta FTP e WebDav.</div>
<div>5.Aggiunte alcune note per ogni cloud drive.</div>`,
        notif_v200: `<div>1.Aggiunto FTP a MultCloud.</div>
<div>2.Aggiunto WebDav a MultCloud.</div>
<div>3.Aggiunta l'opzione di menu: "Copia in".</div>
<div>4.Accesso con account Google e Facebook.</div>
<div>5.Migliorata l'interfaccia utente per renderla più facile da usare.</div>
<div>6.Alcune correzioni di bug.</div>
<div>7.Supportati Cubby, MyDrive, Web.de, Yandex, CloudMe, HiDrive, Copy e BaiDu.</div>`,
        applicationKey: 'Chiave dell\'applicazione',
        keyID: 'keyID',
        privateKey: 'File di chiave privata per l\'autenticazione (facoltativo)',
        privateKey2: 'Chiave privata',
        FTPTips:`1.Assicurati di avere i permessi di lettura / scrittura prima delle operazioni sui file, altrimenti MultCloud potrebbe non essere in grado di trasferire i file sul tuo FTP.
        2. Assicurati che ci sia spazio sufficiente per le tue operazioni. Non siamo temporaneamente in grado di identificarne le dimensioni.
        3. Se non riesci ad accedere al tuo FTP, aggiungi 209.126.103.1/19 e 207.38.89.1/24 alla whitelist del firewall.`,
        specialDropBox:`Se sei un amministratore di Dropbox Business e desideri accedere a tutti gli account della tua organizzazione, si prega di fare clic su "Accedi a Organizzazione".`,
        specialDropBoxBottom:`Se desideri accedere al tuo cloud personale, si prega di fare clic su "Accedi a Cloud Personale".`,
        accessOrganization:'Accedi a Organizzazione',
        accessPersonalCloud:'Accedi a Cloud Personale',
        specialBoxBusiness:`Se sei un amministratore di box for Business e desideri accedere a tutti gli account della tua organizzazione, fai clic su "Accedi a Organizzazione".`,
        specialgSuite:`Se sei un <a href='https://support.google.com/a/answer/2405986?hl=it' target="_blank" class='add-cloud-link'> amministratore di Google Workspace </a> e desideri accedere a tutti gli account della tua organizzazione, "Admin Install" il nostro App Google Workspace Marketplace --- "classe <a href="https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391?hl=it" target="_blank" class='add-cloud-link'>Trasferimento di Cloud – MultCloud</a>" prima. E poi fare clic su "Accesso a Organizzazione".`,
        googleWorkspaceGuideIntro: `Se sei un <a href="https://support.google.com/a/answer/2405986?hl=it" target="_blank" class="add-cloud-link">amministratore di Google Workspace</a> e desideri accedere a tutti gli account della tua organizzazione, procedi come segue:`,
        googleWorkspaceGuideStep1: `Passaggio 1. Vai alla <a href="https://admin.google.com/" target="_blank" class="add-cloud-link">Console di amministrazione</a>. Nel pannello a destra, fai clic su «Sicurezza», quindi vai a «Controllo degli accessi e dei dati» &gt; «Controlli API» &gt; «GESTISCI DELEGA A LIVELLO DI DOMINIO».`,
        googleWorkspaceGuidePersonal: `Se desideri accedere al tuo cloud personale, fai clic su «Accedi al cloud personale».`,
        googleWorkspaceGuideStep2: `Passaggio 2. Fai clic su «Aggiungi nuovo». Nella finestra pop-up, inserisci le seguenti informazioni, quindi fai clic su «Autorizza».`,
        googleWorkspaceGuideStep3: `Passaggio 3. Fai clic su «Accedi all'organizzazione», accedi con il tuo account amministratore e concedi a MultCloud l'accesso alla tua organizzazione.`,
        googleWorkspaceGuideClientId: 'ID client',
        googleWorkspaceGuideScopes1: 'Ambiti OAuth 1',
        googleWorkspaceGuideScopes2: 'Ambiti OAuth 2',
        googleWorkspaceGuideViewImage: 'Visualizza lo screenshot a dimensione intera',
        googleWorkspaceGuideImageAlt: 'Screenshot della configurazione di Google Workspace, passaggio {step}',
        specialOnedrive:`Se sei un amministratore di OneDrive for Business e desideri accedere a tutti gli account della tua organizzazione, fai clic su "Accedi a Organizzazione".`,
        iCloudPhotosTips:'MultCloud per ora non supporta l\'ID Apple non e-mail.',
        appleId: 'ID Apple',
        addICloudPhotos: 'Aggiunge iCloud Foto',
        addICloudDrive: 'Aggiunge iCloud Drive',
        fourShared: `Nota: l'autorizzazione 4shared è valida per<span style="color: red"> 2 ore. </span>Si prega di aggiungere nuovamente 4shared ed eseguire manualmente le proprie attività dopo la scadenza.`,
        fourSharedTips: `Nota: l'autorizzazione 4shared è valida per 2 ore.Si prega di aggiungere nuovamente 4shared ed eseguire manualmente le proprie attività dopo la scadenza.`,
    },
    cloudExploerPopup: {
        googlePhotosV2Tips: 'Suggerimenti per Google Foto',
        googlePhotosV2TipsDesc: 'Google ha aggiornato l\'API di Google Foto il 7 maggio 2025. Per adattarci a queste modifiche, sono stati apportati i seguenti aggiornamenti:',
        googlePhotosV2Tips1: 'La cartella "Album" mostrerà solo gli album creati tramite MultCloud.',
        googlePhotosV2Tips2: 'La cartella "Foto" mostrerà solo le immagini caricate tramite MultCloud.',
        googlePhotosV2Tips3: 'Per trasferire immagini da Google Foto ad altri servizi cloud, fai clic sul pulsante "Aggiungi altre foto" e autorizza MultCloud ad accedere alle immagini che desideri trasferire.',
        googlePhotosV2Tips4: 'Per trasferire immagini da altri servizi cloud a Google Foto, tieni presente che solo le cartelle possono essere trasferite nella cartella "Album", mentre solo le immagini singole possono essere trasferite nella cartella "Foto".',
        googlePhotosV2TipsShow: 'Non mostrare più',
        googlePhotosV2AddMore: 'Aggiungi altre foto',
        googlePhotosV2AddMoreTips: 'Fai clic qui per aggiungere le immagini che desideri caricare su MultCloud.',
        googlePhotosV2FolderName: 'Nome cartella',
        googlePhotosV2FolderNameInput: 'Inserisci un nome per la cartella in cui verranno salvate le immagini.',
        googlePhotosV2NotSelect: 'Non hai ancora aggiunto nessuna foto. Fai clic su "Aggiungi altre foto" per caricare immagini su MultCloud.',
        googlePhotosV2SelectAlbums: 'È possibile salvare solo cartelle in "Album".',
        googlePhotosV2SelectAlbum: 'È possibile salvare solo immagini e video in questa cartella.',
        googlePhotosV2SelectPhotos: 'È possibile salvare solo immagini e video in "Foto".',
        googlePhotosV2SelectSession: 'Questa cartella non può essere selezionata come destinazione. Seleziona invece la cartella "Album" o "Foto".',
        deleteContentEver: 'Sei sicuro di voler eliminare definitivamente gli elementi selezionati?<br>Una volta eliminato, non può essere ripristinato dal Cestino.',
        deleteContent: 'Sei sicuro di voler eliminare gli elementi selezionati?',
        deleteConfirm: 'Confermare l\'eliminazione del file?',
        removeSiteTitle: 'Rimuovi sito',
        removeSiteConfirm: 'Sei sicuro di voler rimuovere questo sito?',
        deleteAction: 'Questa azione non può essere annullata. Il file verrà eliminato definitivamente.',
        deleteDeletion: 'Inserisci il nome del file per confermare l\'eliminazione:',
        deleteDeletionOK: 'Inserisci il nome file corretto per confermare l\'eliminazione',
        detailedProgress: 'Progresso Dettagliato',
        highSpeed: 'La ricerca ad alta velocità supporta i seguenti cloud drive',
        takeMoreTime: 'Potrebbe richiedere più tempo con i seguenti cloud drive',
        enterKeyWord: 'Inserisce la parola chiave',
        highSpeedSearch: 'Ricerca ad Alta Velocità',
        normalSearch: 'Ricerca Normale',
        shareWithOthers: 'Condivide con gli altri',
        inviteByEmail: 'Invita persone tramite e-mail',
        pleaseEnterEmail: 'Inserisce le email e separale con una virgola ',
        addMessage: ' Aggiunge un messaggio (facoltativo)',
        shareTo: 'Condivide a',
        noLink: 'Ancora nessun link creato',
        createShare: 'Creare Condivisione',
        cancelAllTask: 'Sei sicuro di voler annullare tutte le attività?',
        //2020/8/7-xth
        shareEmailTitle: ' Invia link tramite e-mail ',
        // shareCommunityTitleLong: 'Il titolo deve contenere meno di 128 caratteri',
        // shareCommunityDesLong: 'La descrizione deve contenere meno di 256 caratteri',
        shareNotSupportSource: ' Questo servizio cloud non supporta questa funzione, si prega di provare un\'altra opzione di condivisione ',
        shareSendEmail: 'Invia Email',
        generateLinkSuccess: 'Link di condivisione creato',
        generateLinkFail: 'Impossibile creare link di condivisione',
        emailSentSuccessful: 'Email inviate',
        emailSentNull: 'Non hai ancora inserito un\’email',
        emailSentNotice: 'Si prega di inserire un\’email corretta',
        linkCopySuccessful: 'Link copiato!',
        sharePrivateLink: 'Link di condivisione privato:',
        sharePrivatePassword: 'Visualizza password:',
        cancelMyShareTask: 'Sei sicuro di annullare la condivisione? Questo collegamento non funzionerà più per chi lo possiede.',
        cancelMyShareOk: 'Sì, cancellalo',
        cancelMyShareNot: 'No, lo terrò',
        emailArrayToLong50: 'Puoi inviare 50 email alla volta.',
        shareOnEmail: 'Invia link tramite e-mail',
        shareOnFacebook: 'Condivide su Facebook',
        shareOnTwitter: 'Condivide su Twitter',
        shareOnTumblr: 'Condivide su Tumblr',
        shareOnPinterest: 'Condivide su Pinterest',
        shareOnLinkedIn: 'Condivide su LinkedIn',
        ceateShareError: 'Impossibile creare la condivisione, si prega di verificare la tua rete.'
    },
    cloudTransferPopup: {
        pleaSelect: 'Si prega di selezionare',
        schedule: 'Pianificazione',
        //后又新增的
        checkScheduled: 'Selezionare la casella \'Pianificazione\' di questa attività per attivare l\'editor della pianificazione.',
        addValidCloud: 'È necessario aggiungere un cloud drive valido',
         //2020-10-26-ljm增加
         cleanList:'Pulisce Elenco'
    },
    personalCenter: {
        changePassword: 'Modifica Password',
        changeName: 'Cambia Nome',
        deleteAccount: 'Elimina Account',
        enterPassWord: 'Si prega di inserire il tuo password',
        note: 'Nota: Per favore facci sapere il motivo per cui te ne vai, faremo del nostro meglio per correggerlo.',
        sureDeleteAccount: 'Sei sicuro di voler eliminare questo account?',
        unsubscribe: 'Prima di eliminare questo account, si prega di annullare prima l\'iscrizione di MultCloud.',
        bindEmail: 'Associa Email',
        pleaseSwitch: 'Si prega di passare al MultCloud classico per decrittografare i file.',
        switchOld: 'Passa al classico',
        pleaseUnsubscribe: 'Si prega di passare al MultCloud classico per annullare prima l\'iscrizione del tuo servizio avanzato.',
        deletePremium: ' Stai per eliminare un account premium. Una volta eliminato, non potrai più recuperarlo. Sei sicuro di volerlo ancora eliminare?'
    },
    remoteTaskPopup: {
        addLinkTask: 'Aggiunge Attività di Link',
        validLink: ' Inserisce un link valido ',
        saveCloud: 'Salva su Cloud',
        parseFail:'analisi non riuscita',
        inadmissibleRequest:'Una richiesta inammissibile',
        createBtTask: 'Creare Attività BT',
        emptySource: 'Si prega di inserire un link o caricare un file torrent',
        validTorrent: 'Il file torrent selezionato non è valido',
        addTorrent: 'Aggiunge Torrent',
        tip: 'Non hai selezionato un cloud per archiviare questo file',
        torrentSelected:'Nome({num}/{all})',
		urlLinkSupported:"Copia e incolla il link qui, http/https/link magnetici supportati.\nNota: non utilizzare MultCloud per scaricare o caricare materiali copiati in violazione non autorizzati.",
		torrentStore:'Si prega di selezionare un cloud per archiviare il file torrent.',
		downloadLink:'Si prega di immettere un link per il download',
		cancelTask:'Annulla Attività',
		cancelTaskContent:"Sei sicuro di voler annullare l'attività?",
		parseTaskRunning:"MultCloud sta eseguendo un processo di analisi, esegui il \"Scarica Offline\" per verificare."
    },
    taskListPopup: {
        deleteTask: 'Elimina Attività',
        pleaseSelect: 'Seleziona i dati prima di eliminarli.',
        sureDeleteTask: 'Sei sicuro di voler eliminare le attività?',
        deleteSingleTask: 'Sei sicuro di voler eliminare l\’attività?',
        viewLogs: 'Visualizza Registri',
        selectCloud: 'Seleziona il cloud per salvare i file'
    },
    upgradeAccountPopup: {
        commonTitle: '5 attività da cloud a cloud in parallelo',
        commonDes: 'Aggiorna a un abbonato e sarai in grado di eseguire 5 attività da cloud a cloud in parallelo.',
        upgradeAccount: 'Aggiorna Account',
        upgradeHeadTitle:'5 URL o torrent paralleli',
        upgradeHeadContent:"Gli utenti gratuiti possono trasferire 1 URL o attività torrent alla volta. Si prega di aggiornare all\'abbonato e puoi trasferire 5 URL o attività torrent alla volta.",
        currentPlan: 'Piano Corrente',
        insufficientTraffic: 'Traffico da cloud a cloud insufficiente',
        insufficientTrafficDes: 'Hai consumato tutto il traffico di dati gratuito di questo mese. Per ottenere più traffico, si prega di aggiornare alla versione avanzata.',
        filter: 'Filtro di trasferimento/sincronizzazione file',
        filterDes: 'Per attivare il filtro di trasferimento/sincronizzazione dei file, si prega di aggiornare alla versione avanzata.',
        modes: ' Modalità di Sincronizzazione Avanzate ',
        offlineFree: '1 URL o torrent alla volta',
        offlinePremium: '5 URL o torrent paralleli',
        modesDes: 'Gli abbonati possono utilizzare la sincronizzazione bidirezionale e 7 opzioni personalizzate nella sincronizzazione unidirezionale. Sincronizzazione/Backup incrementale supportata.',
        doubleRealTime:'Doppia sincronizzazione in tempo reale',
        doubleRealTimeSyncDes:'Si prega di aggiornare all\'abbonato ed eseguire due attività di sincronizzazione in tempo reale contemporaneamente.',
        doubledSync: 'Doppia sincronizzazione normale',
        doubleSyncDes: 'Si prega di aggiornare all\'abbonato ed eseguire due normali attività contemporaneamente.',
        realTimeSyncing:'Doppia Sincronizzazione In Tempo Reale',
        norMalSyncing:'Doppia Sincronizzazione Normale',
        free: 'Gratis',
        premium: 'Avanzata',
        monthTraffic: '5GB di Traffico/Mese',
        syncMode: '2 Modalità di Sincronizzazione',
        scheduled: 'Trasferimento/Sincronizzazione/Backup Pianificati',
        scheduledDes: 'Per attivare la funzione di Pianificazione, si prega di aggiornare alla versione avanzata.',
        moreTraffic: 'Più traffico di dati ti serve',
        moreSyncModes: '8 Modalità di Sincronizzazione',
        transferSpeed: 'Velocità di Trasferimento Quintuplicata',
        doubleSync: ' Doppia Sincronizzazione ',
        transferServer: 'Servizio di Trasferimento VIP',
        customerSupport: 'Assistenza Clienti VIP',
        syncSupported: ' Sincronizzazione bidirezionale e 7 opzioni personalizzate in Sincronizzazione unidirezionale. Sincronizzazion mirror supportata.',
        greatlyIncreased: 'Ci sono 10 thread per gli abbonati invece di due, quindi la velocità di trasferimento è notevolmente aumentata.',
        sameTime: 'Gli abbonati possono avere 2 attività di sincronizzazione in tempo reale e 2 normali attività di sincronizzazione (4 in totale) eseguite contemporaneamente.',
        normalSametime:'Gli abbonati possono eseguire due normali attività di sincronizzazione contemporaneamente.',
        automatically: 'Imposta un filtro per trasferire o sincronizzare automaticamente i file con un nome file definito dall\'utente o le determinate estensioni.',
        multipleSync: 'Destinazione di Sincronizzazione Multipli ',
        multipleSyncDes: 'Aggiorna all\’edizione avanzata per attivare la funzione Destinazione di Sincronizzazione Multipli.',
        freeDes:'Gli utenti gratuiti hanno 30 GB di traffico dati in totale per trasferire o sincronizzare i dati tra i servizi di archiviazione cloud ogni mese',
        task1: '1 attività da cloud a cloud alla volta',
        task5: '5 attività da cloud a cloud in parallelo',
        emailTitle: 'Conversioni Email Insufficienti',
        emailDes: 'Gli utenti gratuiti hanno 50 conversioni email ogni mese, ma sembra che tu abbia bisogno di più. Esegui l\'upgrade a premium e avrai conversioni email illimitate.',
        emailsConversions: '50 Conversioni Email/Mese',
        emailsUn: 'Conversioni Illimitate di Email',
    },
    remindBindEmail:{
        bindExe:'Associa la tua e-mail per eseguire l\'attività',
        onceBind:'Dopo aver associato la tua email, puoi anche ottenere <span class="gift-flow">30GB</span> di traffico dati aggiuntivo da cloud a cloud!',
        bindEmail:'Si prega di associare la tua email per attivare le funzioni principali di MultCloud.',
        coreFeatures:'Funzioni Principali di Multcloud',
        tourAccount:'Account Turistico',
        connectCloud:'Connette Servizi Cloud a MultCloud',
        viewCloud:'Visualizza tutti i file cloud tramite MultCloud',
        uploadFile:'Carica i file su cloud tramite MultCloud',
        downloadCloud:'Scarica i file da cloud tramite MultCloud',
        syncAndBackup:'Sincronizza e backup i file tra i cloud',
        transferFiles:'Trasferisce i file da uno all\'altro',
        failed:'Impossibile eseguire l\'operazione, riprova più tardi.'
    },
    //todo 待翻译
    salePagePopup:{
        sOffer:'Offerta speciale per piano ILLIMITATO MENSILE',
        timeLimited:'Affrettati, il tempo è limitato!',
        Hours:'Ore',
        Minutes:'Minuti',
        Seconds:'Secondi',
        monthPrice:'$19.9/Mese',
        dataTra:'per traffico dati ILLIMITATO',
        subscribe:'Registrati Ora',
        features:'Funzioni',
        freePlan:'Piano Gratis',
        bigSale:'Grande vendita limitata nel tempo',
        discountsto:'Sconti fino al',
        off:'25%',
        premiumPlan:'Piano Avanzato',
        transmit:'Traffico per trasmissione',
        dataTraffic:'Il traffico dati per il trasferimento e la sincronizzazione di file da cloud a cloud.',
        originalPrice:'Prezzo originale',
        nowOnly:'Ora solo',
        getDiscount:'Ottieni uno sconto',
        moreData:'Più traffico dati',
        unlimitedData:'Traffico dati illimitato',
        syncModes:'Modalità di sincronizzazione',
        syncModesDes:'Gli abbonati dispongono di Sincronizzazione Bidirezionale e 7 opzioni personalizzate di Sincronizzazi.',
        scheduledTran:'Trasferimento Pianificato',
        scheduledTranDes:'Con questa funzione,  puoi creare le attività automatiche da cloud a cloud a intervallo regolare o per un tempo speciale.',
        transferSpeedDes:'Ci sono 10 thread per gli abbonati, invece di 2, quindi la velocità di trasmissine è notevolmente aumentata',
        fileEncryption:'Crittografia dei file',
        encryptFiles:'Gli abbonati possono crittografare i file in cloud drive online e caricare i file',
        quarterly:'Trimestrale',
        yearly:'Annuale',
        monthGb:'150 GB/mensile',
        monthGbly:'200GB/mensile',
        monthfourLy:'400GB/mensile',
        unTr:'Traffico illimitato',
        nMonth:'/Mese',
        tQuarter:'/Trimestre',
        eYear:'/Anno',
        tOneTime:'Una volta',
         //2021-10-09
         premiumFeatures:'150 GB di traffico con tutte le funzioni avanzate per un mese!',
         unlimitedYear:'Traffico illimitato con tutte le funzioni avanzate per un anno!',
         unlimitedLiftime:'Traffico illimitato con tutte le funzioni avanzate a vita!',
    },
    giveawayActiveSucPopup: {
      headerTitle: "Riscatto riuscito!",
      headerSubtitle: "Il tuo abbonamento Premium di 3 mesi è stato attivato! Sblocca l’accesso illimitato a vita con un’offerta esclusiva del 80% di sconto.",
      headerSubtitleYear: "Il tuo abbonamento Premium di 1 anno è stato attivato! Sblocca l’accesso illimitato a vita con un’offerta esclusiva del 80% di sconto.",
      currentPlanBadge: "Attivato",
      currentPlanName: "3 mesi Premium",
      currentPlanNameYear: "1 anno Premium",
      currentPlanPrice: "39,99 €",
      feature1: "Funzionalità Premium di 3 mesi",
      feature1Year: "Funzionalità Premium di 1 anno",
      feature2: "Traffico dati {traffic} per 3 mesi",
      feature2Year: "Traffico dati {traffic} per 1 anno",
      feature3: "Assistenza clienti nei giorni lavorativi",
      upgradePlanBadge: "80% OFF",
      upgradePlanName: "Premium illimitato a vita",
      upgradePlanOriginalPrice: "628 €",
      upgradePlanCurrentPrice: "125.6 €",
      featureUpgrade1: "<b>Funzionalità Premium a vita</b>",
      featureUpgrade2: "Traffico dati <b>illimitato</b>",
      featureUpgrade3: "Assistenza VIP prioritaria <b>24/7</b>",
      featureUpgrade4: "Garanzia di rimborso entro <b>90 giorni</b>",
      countdownLabel: "Offerta esclusiva di upgrade termina tra:",
      btnUpgrade: "Aggiorna ora e risparmia l’80%",
      promoText: "per ottenere l’accesso illimitato a vita",
      off: "OFF",
    },
    properties: 'Proprietà',
    general: 'Generale',
    tips: 'Suggerimenti',
    progress: 'Progresso',
    limits: 'Limiti di Cloud Drive',
    detailed: 'Dettagliata',
    cancel: 'Cancella Tutto',
    simpleSync: 'Sincronizzazione Semplice',
    onewaySync: 'Sincronizzazione Unidirezionale',
    twowaySync: ' Sincronizzazione Bidirezionale ',
    advancedSync: ' Modalità di Sincronizzazione Avanzate ',
    mirrorSync: 'Sincronizzazione Mirror',
    moveSync: 'Sposta Sincronizzazione',
    cmuSync: 'Sincronizzazione Cumulativa',
    updateSync: 'Aggiorna Sincronizzazione',
    increSync: 'Sincronizzazione Incrementale',
    fullSync: 'Sincronizzazione Completa del Backup',
    simpleSyncTip: 'I file aggiunti, modificati ed eliminati nella directory di origine verranno replicati nella directory di destinazione. Tuttavia, i file aggiunti, modificati ed eliminati nella directory di destinazione non verranno replicati nella directory di origine.',
    mirrorSyncTip: 'I file nelle directory di origine e di destinazione sono sempre gli stessi (MultCloud eliminerà i file aggiuntivi nella directory di destinazione).',
    moveSyncTip: 'Una volta completata la sincronizzazione, tutti i file nella directory di origine verranno eliminati.',
    cmuSyncTip: 'Quando si eliminano i file nella directory di origine, gli stessi file nella directory di destinazione non verranno eliminati.',
    updateSyncTip: 'Tutti i file nella directory di destinazione verranno prima eliminati, poi i file aggiunti e modificati nella directory di origine verranno trasferiti nella directory di destinazione.',
    increSyncTip: 'Ogni volta che si sincronizzano i file, verrà creata una sottodirectory nella directory di destinazione in modo che i file aggiunti e modificati nella directory di origine vengano trasferiti ad essa.',
    fullSyncTip: 'Ogni volta che si sincronizzano i file, verrà creata una sottodirectory nella directory di destinazione in modo che tutti i file nella directory di origine vengano trasferiti ad essa.',
    twowaySyncTip: 'I file aggiunti, modificati ed eliminati nella directory di origine verranno replicati nella directory di destinazione. Allo stesso modo, i file aggiunti, modificati ed eliminati nella directory di destinazione verranno replicati nella directory di origine (vale a dire, i file nelle directory di origine e di destinazione sono sempre gli stessi).',
    clone: 'Clona',
    syncModes: 'Modalità di Sincronizzazione',
    email: 'Email',
    filter: 'Filtro',
    thread: 'Thread',
    listThread: 'Numero di thread attraversati',
    runThread: 'Numero di thread eseguiti',
    sameName: 'Stesso nome',
    filterInclude: 'Estensioni incluse (ad es. png, doc, mp4)',
    filterExclude: 'Nomi di file esclusi (ad es. target, dist, build)',
    newFilterTag: 'Nuovo tag',
    createTaskStatus: 'Creato',
    pendingTaskStatus: 'In attesa',
    runningTaskStatus: 'In esecuzione',
    cancelledTaskStatus: 'Annullato',
    completedTaskStatus: 'Riuscito',
    failedTaskStatus: 'Fallito',
    warnTaskStatus: 'Avviso',
    errorTaskStatus: 'Errore',
    warning: 'Avviso',
    logs: 'Registro',
    once: 'Una volta',
    daily: 'Giornaliero',
    weekly: 'Settimanale',
    monthly: 'Mensile',
    onlyOnce: 'Esegue solo una volta:',
    everyDay: 'Esegue ogni giorno alle:',
    everyWeek: 'Esegue ogni settimana a:',
    at: 'A:',
    sunday: 'Domenica',
    monday: 'Lunedì',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedi',
    friday: 'Venerdì',
    saturday: 'Sabato',
    runAt: 'Esegue a:',
    lastDay: 'L\'ultimo Giorno ',
    chooseAction: 'Se il file di destinazione esiste già. Scegli un\'azione:',
    optionsPrompt: 'Se i file nell\'unità cloud di origine hanno un carattere speciale nel nome file che non è consentito nel cloud drive di destinazione, i file verranno rinominati automaticamente durante il processo di trasferimento e un file log.html verrà creato nella directory principale sul cloud drive di destinazione.',
    sourceNewer: 'Sovrascrive se la fonte è più recente.',
    diffSize: 'Sovrascrive se dispone di dimensioni diverse.',
    sourceAll: 'Sovrascrive se dispone di dimensioni diverse o la fonte è più recente.',
    skipFile: 'Salta il file.',
    skipEmail: 'Saltare l\'email.',
    overWrite: 'Sovrascrive sempre.',
    rename: 'Rinomina',
    overWriteSourceNewer: 'Sovrascrivere se c\'è un aggiornamento dell\'email originale.',
    deleteAllSource: 'Elimina tutti i file di origine al termine del trasferimento.',
    keepFileDate: `Mantiene la data di modifica del file (supporta Dropbox, Google Drive, G Suite).`,
    automaRename: 'Rinomina automaticamente i file che contengono caratteri speciali e poi genera un file di script.',
    sendEmail: 'Invia una notifica e-mail al termine di questa attività.',
    sendMessage: 'Invia un messaggio di prova',
    ignoreFiles: 'Ignora i file con queste estensioni',
    includeFiles: 'Include solo i file con queste estensioni',
    selectSync: 'Puoi selezionare la modalità di sincronizzazione qui:',
    tipsFor: 'Suggerimenti per',
    allTasks: 'Tutte le attività',
    successful: 'Riuscita',
    unfinished: 'Incompiuto',
    transferDetails: 'Dettagli di trasferimento',
    redit: 'Modifica di Nuovo',
    publicShare: 'Condivisione Pubblica',
    publicTip: 'Suggerimenti: chiunque riceva il link può visualizzare il file',
    privateShare: 'Condivisione Privata',
    privateTip: 'Suggerimenti: gli altri devono inserire la password per visualizzare il file',
    sourceShare: 'Condivisione Sorgente ',
    sourceTip: 'Suggerimenti: creare un link di condivisione dell\'unità cloud di origine',
    communityShare: ' Pubblico nella Comunità MultCloud ',
    communityTip: 'Suggerimenti: chiunque può trovare e visualizzare il file nella comunità MultCloud',
    shareSuccess: 'Crea Condivisione con Successo',
    copySuccess: 'Copia Riuscita',
    sharedYet: "Questo file è già stato condiviso",
    domain: 'Dominio',
    code: 'Codice',
    resendCode: 'Invia nuovamente il codice',
    key: 'Key',
    secret: 'Secret',
    publicShareEasy: 'Chiunque',
    privateShareEasy: 'Privato',
    communityShareEasy: 'Pubblico',
    sourceShareEasy: 'Sorgente',
     //2020-10-26-ljm增加
    progressBox:'Progresso',
    reportPopup: {
        title: 'Condivisione di Rapporti',
        beforeMsgOne: 'Aiutaci a capire cosa sta succedendo con questa condivisione.',
        beforeMsgTwo: 'Come lo descriveresti?',
        typeItems: {
            spam: 'Spam',
            malwareVirus: 'Malware o virus',
            copyrightViolation: 'Violazione di copyright',
            illegal: 'Contenuto illegale',
            notWorking: 'MultCloud non funziona correttamente',
            other: 'Altri contenuti inappropriati',
        },
        nextMsgOne: 'Si prega di compilare le informazioni su questo rapporto.',
        description: 'Descrizione',
        nextMsgTwo: 'Descrive cosa sta succedendo con la condivisione.',
        yourEmail: 'La tua email',
        nextMsgThree: 'Fornisci il tuo indirizzo e-mail e possiamo contattarti se necessario.',
        submit: 'Invia',
        back: 'Indietro',
        next: 'Avanti',
        messageNone: 'Si prega di inserire la descrizione di questo rapporto.',
        emailNone: 'Si prega di inserire la tua email di contatto.',
        success: 'Il tuo rapporto è già stato inviato al team MultCloud.'
    },
    subAccountPopup:{
        title: "Gestione dei sottoconti",
        titleMax: "Gestione dei sottoconti",
        titleDes:"Si prega di aggiornare ad abbonato e sarai in grado di creare e gestire account secondari.",
        tabNameUser: "Modalità di utente",
        tabNameItem: "Modalità di cartella",
        addItemButton: "Assegna Cartella",
        users: "Utenti",
        folders: "Cartelle",
        read: "Leggere",
        write: "Scrivere",
        questionTxtRead: "Gli utenti di sottoconti possono scaricare, vedere in anteprima e copiare i file sui propri cloud in questa cartella.",
        questionTxtWrite: "Gli utenti di sottoconti possono creare nuove cartelle, caricare, eliminare, rinominare i file in questa cartella.",
        userExist:"L'utente è già esistente.",
        userSelf:"Non puoi aggiungerti come il tuo account secondario.",
        quickAssign: "Assegnazione rapida",
        quickAdd: "Aggiunta rapida",
        allow: "Consenti",
        batchAddUserNull: "Al momento non è stato aggiunto alcun utente.",
        batchAddItemNull: "Al momento non è stata aggiunta alcuna cartella.",
        noUserFromAddItem: "Aggiungi prima un utente.",
        noItemFromAddUser: "Aggiungi prima una cartella.",
        addUser: {
            title: "Aggiunge Utente",
            radioCreate: "Crea un sottoconto",
            radioAdd: "Aggiunge un account MultCloud esistente",
            createNamePlaceholder: "Crea nome utente",
            createPasswordPlaceholder: "Crea Password",
            addNamePlaceholder: "Inserisci l'account MultCloud esistente",
            createNameNone: "Inserisci un nome utente.",
            createNameMore: "Il nome utente deve contenere meno di 20 caratteri.",
            createPasswordNone: "Inserisci una password.",
            createPasswordError: "Inserisci una password con 8-16 caratteri.",
            addUserNameNone: "Inserisci un account MultCloud esistente.",
            addUserNone: "Questo account non esiste.",
        },
        addItem: {
            noFolder: "Si prega di selezionare una cartella.",
            exist: "Hai già aggiunto la cartella.",
        },
        editUser: {
            title: "Modifica Sottoconto",
            namePlaceholder: "Inserisci un nome utente",
        },
        cancel: {
            titleUser: "Elimina Sottoconto",
            titleItem: "Rimuove Cartella",
            msgUser: "Sei sicuro di voler eliminare questo account?",
            msgItem: "Sei sicuro di rimuovere questa cartella?",
        },
        unknownError: "Impossibile trovare il percorso, controlla se il percorso esiste o aggiungi il cloud di nuovo.",
    },
    verifyPopup:{
        verifyTitle: "Verifica la tua identità",
        toRecoveryText: "Non ho nessuno di questi",
        verifyEmailTitle: "Verifica la tua email",
        verifyEmailTips: "Invieremo un codice di verifica a {email}. Per verificare che questo sia il tuo indirizzo e-mail, inseriscilo qui sotto",
        verifyPhoneTitle: "Verifica il tuo numero di telefono",
        verifyPhoneTips: "Invieremo un codice di verifica a {phone}. Per verificare che questo sia il tuo numero di telefono, inserisci le ultime 4 cifre, incluso {last}.",
        verifyPhoneText: "Le ultime 4 cifre del numero di telefono",
        sendCodeBtn: "Invia Codice",
        enterCode: "Inserisci il codice",
        checkEmailTips: "Se {email} corrisponde all'email alternativa del tuo account, ti invieremo un codice.",
        checkPhoneTips: "Se {phone} corrisponde alle ultime 4 cifre del numero di telefono nel tuo account, ti invieremo un codice.",
        askDevice: "Non chiedermi di nuovo su questo dispositivo",
        verify: "Verifica",
        recoveryTitile: "Hai un codice di recupero dell'account?",
        recoveryTipsOne: "Se hai un codice di recupero, inseriscilo ora. Se non ne hai uno, si prega di contattarci",
        recoveryTipsTwo: "Il tuo codice di recupero è lungo 25 caratteri, come questo: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX.",
        recoveryCode: "Codice di Recupero",
        recoveryCodeBtn: "Usa codice di recupero",
        recoveryChangeTitile: "Cos'altro possiamo verificare la tua identità?",
        recoveryEmailChange: "Aggiungi un indirizzo e-mail alternativa",
        recoveryPhoneChange: "Aggiungi un numero di telefono",
        enterEmail: "Inserisci la tua email",
        recoveryNextTitle: "Inserisci il codice che inviamo a {checkCode}",
        recoveryTipsTitle: "Per la tua protezione, la sostituzione delle informazioni di sicurezza richiede 30 giorni!",
        recoveryTips1: "Poiché hai attivato la verifica in due passi, hai bisogno dell'ultime informazioni di sicurezza per accedere al tuo account.",
        recoveryTips2: "Durante il periodo di attesa non sarà in grado di accedere a siti o servizi con il suo account, ma potrai accedere ai dispositivi",
        recoveryTips3: "Puoi evitare l'attesa da:",
        recoveryTips4: "Utilizza un dispositivo affidabile.",
        recoveryTips5: "Se hai un dispositivo che non richiede codici, si prega di usarlo ora e aggiornare le tue informazioni di sicurezza.",
        recoveryTips6: "Trova le tue informazioni sulla sicurezza",
        recoveryTips7: "È possibile che non sia completamente perso? Se riesci a trovarlo, usalo ora per riabilitare il tuo account.",
        recoveryTips8: "L'attesa rende più difficile per qualcun altro prendere il controllo del tuo account con una password rubata.",
        recoveryPendTitle: "La modifica delle tue informazioni di sicurezza è ancora in sospeso",
        recoveryPendTips1: "Su {data} hai richiesto la sostituzione delle tue informazioni di sicurezza",
        recoveryPendTips2: "Informazioni correnti sulla sicurezza",
        recoveryPendTips3: "E-mail alternativa:",
        recoveryPendTips4: "Numero di telefono:",
        recoveryPendTips5: "Nuove informazioni sulla sicurezza",
        recoveryPendTips6: "Se vuoi mantenere le tue attuali informazioni di sicurezza,",
        recoveryPendTips7: "annulla questa richiesta.",
        recoveryCancelTitle: "Ecco il tuo nuovo codice di recupero",
        recoveryCancelTips1: "Per garantire la sicurezza del tuo account, hai bisogno di un nuovo codice di recupero.",
        recoveryCancelTips2: "Se hai bisogno di recuperare l'accesso al tuo account, questo codice ti aiuterà. Dovresti scriverlo e conservarlo in un luogo sicuro. Ti consigliamo vivamente di non conservare il tuo codice di recupero su un dispositivo.",
        recoveryCancelTips3: "Se prima avevi un codice di recupero, non è più valido. Usa invece questo nuovo codice.",
        recoveryCancelTips4: "Il tuo nuovo codice è:",
        recoveryCancelSucTitle: "Perfetto! Torniamo al tuo account!",
        recoveryCancelSucTips1: "L'aggiornamento delle informazioni di sicurezza per {old} è stato annullato, e ora puoi accedere completamente al tuo account.",
        recoveryCancelSucTips2: "Le informazioni di contatto usate per iniziare il processo ({new}) sono state eliminate e non verranno utilizzate come informazioni di sicurezza per il tuo account",
        recoveryCancelSucTips3: "Fai clic su \"Next\" per tornare a quello che stavi facendo.",
        recoveryCancelErrorTitle: "Invia la richiesta",
        recoveryCancelErrorTips: "Il tuo account è ancora nel periodo di attesa.",
        codeText: "Inserisci il tuo numero di telefono",
        exception: {
            emailTwoStringError: "L'email corretta inizia con \"{errorCode}\".",
            validEmail: "Si prega di inserire un'e-mail corretta.",
            phoneLastTwoStringError: "Il numero corretto finisce in {errorCode}.",
            validPhone: "È necessario inserire le ultime 4 cifre del numero di telefono.",
            verificationCodeExpired: "Il codice di verifica è scaduto.",
            verificationCodeError: "Il codice di verifica non è corretto, controlla il codice e riprova.",
            verificationRecoveryCodeExpired: "Il codice non ha funzionato, controlla il codice e riprova.",
            verificationCodeNull: "Si prega di inserire un codice di verifica.",
        }
    },
    worldBackupPopup: {
        // title:'World Backup Day',
        title:'Offerta Speciale di MultCloud',
        titleTip:'Vendita Flash di 24 Ore',
        timerTitle:'L\'offerta a tempo limitato terminerà tra',
        getOffer:'Ottieni un\'offerta',
        tips100Mo:'100GB/Mese traffico dati',
        ps100Mo:'Nota: il traffico dati inutilizzato si accumulerà. Per esempio, hai consumato solo 50GB di 100GB nel primo mese e avrai ancora 50 GB di traffico dati aggiuntivo nel mese successivo.',
        tips1200Yr:'1200GB/Anno traffico dati',
        ps1200Yr:'Nota: il traffico dati inutilizzato si accumulerà. Per esempio, hai consumato solo 1000GB di 1200GB nel primo anno e avrai ancora 200GB di traffico dati aggiuntivo l\'anno successivo.',
        tips2400Yr:'2400GB/Anno traffico dati',
        ps2400Yr:'Nota: il traffico dati inutilizzato si accumulerà. Per esempio, hai consumato solo 2000GB di 2400GB nel primo anno e avrai ancora 400GB di traffico dati aggiuntivo l\'anno successivo.',
        tipsUnYr:'Illimitato/Anno traffico dati',
        psUnYr:'Nota: Traffico dati illimitato per un anno!',
        tipsUnLi:'Illimitato/A Vita traffico dati',
        psUnLi:'Nota: Traffico dati illimitato per tutta la vita!',
        tips1:'10 thread per trasferire file',
        tips2:'Trasferimento di cloud pianificato',
        tips3:'24/7/365 supporto prioritario',
        ps1:'Ci sono 10 thread per gli abbonati, mentre 2 per gli utenti gratuiti, quindi la velocità di trasferimento è notevolmente aumentata.',
        ps2:'Gli abbonati possono pianificare il trasferimento o la sincronizzazione automatica da cloud a cloud a intervalli regolari o per orari speciali.',
        moPrice:'{price} / Mese',
    },
    iosPayTipPopup: {
        title: 'Annullare l\'abbonamento Apple',
        tip: 'I tuoi attuali {subscription} sono in stato di rinnovo automatico (ID transazione Apple: {ID}), annulla l\'abbonamento e riprova.',
        btnTxt: 'Come annullare',
    },
    appRecommendPopup: {
        title: 'La nuova app mobile MultCloud è ora disponibile!',
        tip: 'Scarica ora per gestire e trasferire <br>dati tra i cloud con dispositivi mobili.',
        modileTitle: 'Ottieni subito l\'app mobile MultCloud!',
        iosBtnTitle: 'Scarica su',
        iosBtnTip: 'App Store',
        androidBtnTitle: 'GAUTI IŠ',
        androidBtnTip: 'Google Play',
        apkBtnTitle: 'Scarica',
        apkBtnTip: 'MultCloud',
    },
    note: 'Nota',
    editCloudNoticPopup: {
        tips: 'L\'autorizzazione è scaduta, si prega di aggiungere nuovamente il cloud a MultCloud e riprovare.',
        btnTxt: 'Riaggiungi',
    },
    appleTipsPopup: {
        title: 'Suggerimenti',
        tipTitle: 'Suggerimenti per l\'autenticazione a due fattori con foto di iCloud',
        tip1: 'Per connettere le tue foto di iCloud a MultCloud, devi autorizzare i server MultCloud ad accedere al tuo ID Apple. Pertanto, durante il processo di autenticazione a due fattori, potresti vedere che la posizione del nostro server è diversa dalla tua posizione effettiva.',
        tip2: 'La tua sicurezza e privacy sono la nostra priorità numero uno. MultCloud può temporaneamente memorizzare nella cache alcuni contenuti in base alle tue operazioni, ma non memorizzerà in modo permanente i tuoi dati. Questi dati verranno cancellati dai nostri server immediatamente dopo il completamento dell\'operazione. La connessione tra i tuoi server foto di iCloud e MultCloud avviene sempre tramite un protocollo SSL sicuro a 256 bit.',
        checkTip: 'Non mostrarlo di nuovo',
    },
    iCloudDriveTips: {
        title: 'Suggerimenti',
        tipTitle: 'Suggerimenti per l\'autenticazione a due fattori di iCloud Drive',
        tip1: 'Per collegare iCloud Drive a MultCloud, devi concedere l\'accesso al server MultCloud al tuo ID Apple. Quindi, durante la procedura di autenticazione a due fattori, potresti vedere che la posizione del nostro server è diversa dalla tua posizione reale.',
        tip2: 'Si prega di ricordare: la tua sicurezza e la tua privacy sono la nostra priorità numero uno. MultCloud non memorizza i tuoi dati in modo permanente. Potrebbe memorizzare temporaneamente parte del contenuto nella cache in base alle tue operazioni, ma verrà rimosso immediatamente dal nostro server una volta completata l\'operazione. La connessione tra i server iCloud Drive e MultCloud avviene sempre tramite un canale SSL sicuro a 256 bit.',
        checkTip: 'Non mostrarlo di nuovo',
    },
    checkApplePopup: {
        title: 'Autenticazione a due fattori',
        tip1: 'Hai attivato l\'autenticazione a due fattori. Inserisci il codice di verifica sul tuo iPhone/iPad/iPod per continuare.',
        tip2: 'Non hai ricevuto un codice di verifica?',
        btn1: 'Invia messaggio...',
        btn2: 'Codice di rispedizione',
        btn3: 'Scrivimi',
        btn4: 'Ottieni supporto',
        suc1: 'Un messaggio con un codice di verifica è stato inviato a {num}.',
        suc2: 'Un messaggio con un codice di verifica è stato inviato ai tuoi dispositivi.',
        fail1: 'Impossibile inviare il codice di verifica, riprova.',
        fail2: 'Inserisci il codice di verifica per continuare.',
    },
    downloadThreadPopup: {
        title: "Impostazioni di Download",
        tips: "Nome del file scaricato",
        defaultNameOne: "Emails saved on {date}",
        defaultName: "{num} emails saved on {date}",
        option1: "Salva allegato",
        option2: "Formato della conversazione",
        option2Tips: "Quando selezioni, il contenuto citato dell'e-mail verrà rimosso.",
        option3: "Salva solo l'ultimo messaggio",
    },
    failedFilesPopup: {
        title: 'File non riusciti: {num} ',
        exportExcel: 'Esporta in formato Excel',
        retrySucTip: '{num} elementi aggiunti all\'elenco di ritentativi',
    },
    viewLogsPopup: {
        title: 'Dettagli attività:',
        titleRe: 'Dettagli ripristino:',
        errorNum: 'Elementi non riusciti',
        addNum: 'File aggiunti',
        updateNum: 'File modificati',
        deleteNum: 'File eliminati',
        syncSize: 'Dimensione sincronizzata',
        syncTime: 'Durata sincronizzazione',
        backupNum: 'Numero di backup',
        backupSize: 'Dimensione del backup',
        backupTime: 'Durata del backup',
        restoreNum: 'Numero di ripristini',
        restoreSize: 'Dimensione di ripristino',
        restoreTime: 'Tempo di ripristino',
        cloneNum: 'Numero di clonazioni',
        cloneSize: 'Dimensione della clonazione',
        cloneTime: 'Tempo di clonazione',
        tranNum: 'Numero di trasferimenti',
        tranSize: 'Dimensione trasferita',
        tranTime: 'Durata del trasferimento',
        from: 'Origine:',
        to: 'Destinazione:',
        executeTime: 'Orario di esecuzione:',
        sourceAccount:'Account di origine',
        targetAccounts:'Account di destinazione',
        executeResult: 'Risultato dell\'esecuzione',
        add: 'Aggiunti:',
        update: 'Aggiornati:',
        delete: 'Eliminati:',
    },
    taskProgressPopup: {
        title1: 'Sei un utente premium, ora puoi trasferire file con 10 thread simultaneamente.',
        title2: 'Aggiorna a qualsiasi servizio premium per avere fino a 10 thread!',
        btnTip: 'A partire da $9,99',
    },
    subfileSelectPopup: {
        title: 'Seleziona contenuto da caricare',
    },
    deleteBatchPopup: {
        tips1: 'Sei sicuro di voler eliminare questi <span>{num}</span> task?',
        tips2: 'Una volta eliminati, non sarà possibile recuperarli.',
    },
    freeSaledPopup: {
        tips1: 'Mantieni i ricordi della tua famiglia connessi tra diverse nuvole — ricevi 10 GB GRATIS per questo Family Day!',
        tips2: 'Aspetta!',
        tips3: 'Sembra che tu stia saltando il regalo per la Festa del Papà. Solo un promemoria: una volta saltato, non sarà più disponibile!',
        btns1: 'Richiedi 10GB',
        btns2: 'No, grazie',
        success: 'Congratulazioni! Hai appena ricevuto 10GB di traffico per il trasferimento tra cloud.',
        floatTitle: 'OTTIENI 10 GB GRATIS',
        popupTitle: 'OTTIENI <span>10 GB</span> GRATIS',
    }
},
addCloud: {
    connectDesc: 'Seleziona un servizio da connettere.',
    box: 'Box',
    boxBusiness:'box for Business',
    dropbox: 'Dropbox',
    google_drive: 'Google Drive',
     google_drive_sharedWithMe: 'Shared with me',
    google_drive_v2: 'Google Drive',
    google_drive_shared_v2: 'Shared with me',
    oneDrive: 'OneDrive',
    oneDriveV2: 'OneDrive',
    sugarSync: 'SugarSync',
    amazonS3: 'Amazon S3',
    iDrivee2: 'IDrive® e2',
    wasabi:'wasabi',
    webDav: 'WebDAV',
    FTP: 'FTP',
    cloudMe: 'CloudMe',
    cubby: 'Cubby',
    myDrive: 'MyDrive',
    yandex: 'Yandex',
    hiDrive: 'HiDrive',
    WEBDE: 'WEB.DE',
    baiDu: 'BaiDu',
    amazon: 'Amazon',
    alfresco: 'Alfresco',
    aDrive: 'ADrive',
    Icedrive: 'Icedrive',
    NAS: 'NAS',
    oneDrive4Business: 'OneDrive per Business',
    dropbox4Business: 'Dropbox per Business',
    pCloud: 'pCloud',
    mega: 'MEGA',
    backblaze: 'Backblaze',
    putio: 'Putio',
    googlePhotos: 'Google Foto',
    googlePhotosV2: 'Google Foto',
    gSuiteSharedDrive: 'Shared Drive',
    evernote: 'Evernote',
    flickr: 'Flickr',
    mediafire: 'MediaFire',
    ownCloud: 'ownCloud',
    mySQL: 'MySQL',
    gSuite: 'Google Workspace',
    hubiC: 'hubiC',
    egnyte: 'Egnyte',
    youtube: 'youtube',
    facebook: 'facebook',
    picasa: 'picasa',
    goDaddy: 'goDaddy',
    ubuntu: 'ubuntu',
    welcomeTo: 'Benvenuto in MultCloud',
    peCloud: 'Servizi personali',
    buCloud: 'Servizi aziendali',
    welcomeFont: 'Ora puoi trasferire e gestire facilmente tutti i tuoi file cloud con un\'unica app. Per prima cosa, si prega di collegare il tuo cloud a MultCloud.',
    sharePointOnline:"SharePoint Online",
    iCloudPhotos: 'iCloud Foto',
    gmail: 'Gmail',
    comingSoon: 'Prossimamente...',
    iCloudDrive: 'iCloud Drive',
    signInWith: 'Accedi con',
    outlook: 'Outlook',
    fourShared: '4shared',
    google_workspace: 'Google Workspace',
},
addEmail: {
    connectDesc: 'Fare clic sull\'email per collegarla a MultCloud',
    peEmail: 'Seleziona e accedi con l\'e-mail',
    iCloudNotice: 'iCloud Drive è temporaneamente non disponibile per la connessione e il nostro team di sviluppo sta lavorando per risolvere il problema.',
    iCloudPhotosNotice: 'Foto di iCloud è temporaneamente non disponibile per la connessione e il nostro team di sviluppo sta lavorando per risolvere il problema.',
},
cloudExploer: {
    uploadFile: 'Carica File',
    newFolder: 'Nuova Cartella',
    newAlbum: 'Nuovo album',
    search: 'Ricerca',
    grid: 'Griglia',
    pageList: 'Elenco',
    reFresh: 'Ricarica',
    modified: 'Modificato su',
    openWith: 'Aperta con ',
    officeOnline: 'Microsoft Office Online',
    loading: 'Si Prega di attendere, caricamento in corso ...',
    uploadFolder: 'Carica Cartella',
    trash: 'Cestino',
    recentlyDeleted: 'Eliminato di Recente',
    jumpTo: 'Salta a',
    deleteForever: 'Elimina per sempre',
    restore: 'Ripristina',
    back: 'Indietro',
    searchResult: 'Risultato di Ricerca',
    emptyTrash: 'Svuota Cestino',
    recoverAll: 'Recuperare Tutto',
    deleteAll: 'Eliminare Tutto',
    fileExists: 'File Esiste',
    chooseOption: 'File Esiste, si prega di scegliere un\'opzione!',
    needRestore: 'Per visualizzare questa cartella, dovrai ripristinarla dal cestino',
    limitBoxTip: '1. Alcuni cloud drive potrebbero avere alcune limitazioni. Ad esempio, Box non supporta la trasmissione di un singolo file di dimensioni superiori a 2 GB. Tali limitazioni sono stabilite dal fornitore di servizi cloud e non possono essere superate da MultCloud. Per maggiori informazioni, si prega di <a href="https://www.multcloud.com/help/limitations.html" target="_blank" class="add-cloud-link">fare clic qui</a>.<br>2. Se le tue attività non hanno ancora ricevuto 10 thread dopo l\'aggiornamento all\’edizione avanzata, si prega di annullare e trasferire nuovamente le attività. Le tue attività riceveranno 10 thread da trasferimento con servizi esclusivi vip.',
    fileNameNotEmpty: 'Il nome del file inserito non può essere vuoto.',
    notContainSpecialChar: 'Il nome del file non può contenere caratteri speciali `/ \ | : * ? " < >`.',
    CharacterLimit:'Il nome del file non può contenere caratteri speciali `~"# %& *: < >？ / \ { | }.`',
    pathNotExist: 'Il percorso non esiste',
    emptyNotice: 'Questa cartella è vuota',
    trashEmpty: 'Il cestino è vuoto',
    searchEmpty: 'I risultati della ricerca sono vuoti',
    tooManyFiles: 'Ci sono troppi file, quindi i file caricati in precedenza non verranno più visualizzati.',
    uploadSize: 'La dimensione totale di un\'attività di caricamento non può superare 1 GB.',
    simultaneous: 'Puoi aggiungere al massimo 200 attività contemporaneamente.',
    cancelFailed: 'Annullamento non riuscito, attività in fase di creazione, si prega di riprovare più tardi',
        taskCanceling: 'L\'attività è in fase di annullamento, si prega di riprovare più tardi',
    notWith: 'I nomi dei file e delle cartelle non possono iniziare o finire con "."',
    notUpload: 'caricamento fallito.',
    duplicatePhoto: 'Foto duplicata. La foto che stai cercando di caricare è un duplicato e non è stata importata nella tua libreria.',
    dataLoaded:'Dati caricati',
    sharedDate:'Data condivisa',
    failedRestore: 'Impossibile ripristinare il file, perché la directory di destinazione contiene un file con lo stesso nome.',
    uploadError:'È stato vietato scaricare questo file dal cloud drive ufficiale.',
    downloadLimit: 'È stato raggiunto il limite di download per oggi. Per favore, riprova domani.',
    //2022-4-26 wt
    newBucket:'Nuovo Bucket',
    createBucket:'Il nome del bucket deve contenere solo le lettere minuscole e i numeri. La lunghezza dovrebbe essere di 3-63 caratteri. p.s. Il nome del bucket non deve essere composto da tutti i numeri (ad es. "12345678").',
    deleteBucket: 'MultCloud non può eliminare i bucket con una convenzione di denominazione di tutti i numeri (ad esempio "12345678").',
    getBucketObjectListFail :'MultCloud non può elencare un bucket con una convenzione di denominazione di tutti i numeri (ad esempio "12345678").',
    newAlubm: '',
    specialCharError: 'Il nome del file non può contenere caratteri speciali `/ | : * ? " < >`.',
    copiedToClipboard: 'Copiato negli appunti',
    inputTitle: 'Titolo',
    inputPlaceholder: 'Inserisci contenuto',
    pleaseInputContent: 'Inserisci il contenuto',
    pleaseEnterBucketName: 'Inserisci il nome del bucket',
    pleaseEnterFolderName: 'Inserisci il nome della cartella',
    pleaseInputNewName: 'Inserisci il nuovo nome',
},
emailExploer: {
    from: 'Mittente',
    to: 'Destinatario',
    cc: 'cc',
    email: 'Email',
    subject: 'Tema',
    received: 'Tempo di ricezione',
    sentTime: 'Tempo di spedizione',
    downloadMax200: 'Al massimo, puoi scaricare 200 email alla volta.',
    noSubject: '(nessun oggetto)',
    folderName: {
        Inbox: 'Posta in arrivo',
        Starred: 'Speciali',
        Snoozed: 'Posticipati',
        Sent: 'Inviati',
        Drafts: 'Bozze',
        Important: 'Importanti',
        Chats: 'Chat',
        Scheduled: 'In programma',
        AllMail: 'Tutti i messaggi',
        Spam: 'Spam',
        Trash: 'Cestino',
        Unread: 'Da leggere',
        Categories_Social: 'Categorie_Social',
        Categories_Updates: 'Categorie_Aggiornamenti',
        Categories_Forums: 'Categorie_Forum',
        Categories_Promotions: 'Categorie_Promozioni',
        Categories_Personal: 'Categorias_Personal',
    }
},
imageSaver: {
    analyzing: 'Analisi in corso',
    failedToParse: 'Analisi non riuscita',
    noviceGuidance: 'Puoi controllare qui tutte le immagini/video recentemente caricati sul cloud o immagini/video pacchettizzati per Instagram.',
    insDownloadExist: 'Hai già scaricato questo profilo. Puoi trovarlo nella sezione "Elenco delle attività".',
    taskExpiredOn: 'Scaduto il {time}',
    taskStoringTill: 'Memorizzazione fino al {time}',
    taskPart: 'Parte',
    taskUnitFile: 'file',
    taskUnitFiles: 'file',
    taskQueue: 'In coda',
    taskTabUpload: 'Carica',
    taskTabSaveAll: 'Salva tutto sul cloud',
    taskTabDownload: 'Scarica tutto da IG',
    downloadInsVideo: 'Scarica il video',
    downloadSinglePost: 'Scarica l\'intero post',
    downloadAllPosts: 'Scarica tutti i post',
    downloadAllReels: 'Scarica tutti i reels',
    downloadAllStories: 'Scarica tutte le storie',
    downloadAllHighlights: 'Scarica tutti gli highlights',
    saveInsVideo: 'Salva il video nel cloud',
    saveSinglePost: 'Salva l\'intero post nel cloud',
    saveAllPosts: 'Salva tutti i post nel cloud',
    saveAllReels: 'Salva tutti i reels nel cloud',
    saveAllStories: 'Salva tutte le storie nel cloud',
    saveAllHighlights: 'Salva tutti gli highlights nel cloud',
    insCardPosts: 'post',
    insCardFollowers: 'follower',
    insCardFollowing: 'seguiti',
    insTabPosts: 'Foto e Video',
    insTabReels: 'Reels',
    insTabStories: 'Storie',
    insTabHighlights: 'Highlights',
    insBlankText: 'Con Instagram Downloader di MultCloud, scarica e salva facilmente post, reels, storie e highlights di Instagram per gestire i tuoi contenuti preferiti in qualsiasi momento.',
    webGoogleBlankText: 'Raccogli facilmente immagini da qualsiasi sito web o ricerca su Google e salvale direttamente sul tuo cloud o archivio locale.',
    noTask: 'Nessun compito',
    inputTipHttp: 'Inserisci un URL del sito web o una parola chiave di ricerca su Google',
    fetchBtn: 'Recupera Ora',
    fetchingBtn: '',
    loadMore: 'Carica altro',
    downloadAll: 'Scarica tutto',
    saveAll: 'Salva tutto sul cloud',
    saveToCloud: 'Salva nel cloud',
    clearHistory: 'Cancella la cronologia',
    cancel: 'Annulla',
    retry: 'Riprova',
    view: 'Visualizza',
    noImage: 'Nessun contenuto trovato',
    notSupport: 'Forse questo URL non è supportato. Verifica l\'URL e riprova.',
    inputTipIns: 'Inserisci un URL di Instagram',
    post: 'post',
    posts: 'post',
    uploadTo: 'Carica su: ',
    download: 'Scarica',
    uploading: 'Uploading',
    finished: 'Finished',
    all: 'Tutti',
    videoInputTip: 'Incolla il link del tuo video qui',
    videoTip: `Scarica video di alta qualità da YouTube, Facebook, X e oltre <a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1000 altri siti</a>
    con l'Online Video Downloader di MultCloud senza pubblicità e multipiattaforma—nessuna installazione richiesta.`,
    process: 'Elaborazione in corso...',
    thumbnail: 'Miniatura',
    abrTypeVeryHigh: 'Molto Alta',
    abrTypeHigh: 'Alto',
    abrTypeNormal: 'Normale',
    abrTypeLow: 'Bassa',
    default: 'Predefinito',
    generat: 'Generazione del file',
    retryTip: 'L\'attività è stata riavviata. Puoi visualizzare i progressi più recenti nella scheda "Tutti".',
},
taskList: {
    taskListDes: 'Qui puoi gestire il trasferimento nel cloud, la sincronizzazione nel cloud e la memoria dei file condivisi',
    multiCloudSync: 'Sincronizzazione Multi-Cloud',
    MultiCloudTransfer: 'Trasferimento Multi-Cloud',
    nextTransfer: 'Trasferimento Successivo',
    scheduled: 'Pianificato',
    nextSync: 'Sincronizzazione Successivo',
    reTransfer: 'Ritrasferisce',
    saveNow: 'Salva Ora',
    transferTasks: 'Attività Trasferimento',
    syncTasks: 'Attività Sincronizzazione',
    shareTasks: 'Attività Condivisioine',
    backupTasks: 'Attività Backup',
    emailTransferTasks: 'Email Migration Tasks',
    allTime: 'Tutto il Tempo',
    today: 'Oggi',
    latestWeek: 'Ultima Settimana',
    latestMonth: 'Ultimo Mese',
    customDate: 'Data Personalizzata',
    allStatus: 'Tutti gli Stati',
    preset: 'Preimpostato',
    noTaskCreated: 'Nessuna attività è stata creata',
    createTransferTask: 'Creare un\'attività di trasferimento',
    createSyncTask: 'Creare un\'attività di sincronizzazione',
    createRemoteTask: 'Creare un\'attività remota',
    timeMustLess: 'L\'ora di inizio deve essere inferiore o uguale all\'ora di fine',
    taskNameRule: 'Il nome dell\'attività non può superare i 200 caratteri',
    backupTaskNameRule:'Il nome dell\'attività non può superare i 255 caratteri',
    detailNote: 'Questa attività è ancora in fase di preparazione, nessun progresso dettagliato da mostrare.',
    notTraffic: 'Traffico di dati insufficiente per la trasmissione da cloud a cloud',
    reSync:'Ri-sincronizzazione',
    rebackup:'Nuovo backup',
    rerestore:'Ri-ripristina',
    //2021-10-11
    createBackupTask:'Crea un\'attività di backup',
    createTeamTransferTask:'Creare un\'attività di trasferimento del team',
    multiClouds: 'Multi-cloud',
    speedUP: 'Accelera',
    noTasks: 'Nessuna attività',
    noTasksTip: 'Fai clic sui pulsanti qui sotto per creare un\'attività.',
    startCloudTransfer: 'Avvia trasferimento cloud',
    startCloudSync: 'Avvia sincronizzazione cloud',
    loadingTip: 'Un momento, per favore.',
    allTasks: 'Tutte le attività ({num})',
},
cloudTransfer: {
    transferDescription: 'Imposta un\'attività di trasferimento per trasferire i file tra i Cloud Drive',
    transferOperateFrom: 'Fa clic qui per selezionare i cloud drive o le cartelle da cui eseguire il trasferimento',
    from: 'DA',
    to: 'A',
    transferOperateTo: 'Fa clic qui per selezionare i cloud drive o le cartelle a cui voresti eseguire il trasferimento',
    transferNow: 'Trasferisce Ora',
    transfer: 'Trasferimento',
    addTaskOnly: 'Solo Aggiunge Attività',
    addTaskNow: 'Aggiunge Attività e Trasferisce Ora',
    addSyncTaskNow: 'Aggiunge Attività e Sincronizza Ora',
    addBackupTaskNow:'Aggiungi attività e backup adesso',
    transferSucces: 'Trasferimento Riuscito',
    sureContinue: 'Hai selezionato più di 10 elementi di origine e ogni elemento di origine corrisponde a un\'e-mail di notifica. Ciò significa che potresti ricevere più di 10 e-mail di notifica. Sei sicuro di continuare?',
    sure: 'Sì, sono sicuro.',
     //2020-10-29ljm新增
     sourceRemind:'Il numero massimo di elementi di origine è 200. Seleziona meno elementi o seleziona un\'intera cartella. P.S. Un\'intera cartella conta solo un elemento.',
     backupSourceRemind:'Il numero massimo di elementi di origine è 1000. Seleziona meno elementi o seleziona un\'intera cartella. P.S. Un\'intera cartella conta solo un elemento.'
},
cloudSync: {
    syncDescription: 'Imposta un\'attività di sincronizzazione per sincronizzare i file tra i cloud drive',
    syncOperateTo: 'Fare clic qui per selezionare i cloud drive o le cartelle a cui voresti eseguire la sincronizzazione',
    syncOperateFrom: 'Fare clic qui per selezionare l\'unità cloud o la cartella da cui eseguire la sincronizzazione',
    syncNow: 'Sincronizza Ora',
    taskEmpty: 'Il nome dell\'attività non può essere vuoto.',
    aimRemind:'Il numero massimo di directory di destinazione è 200.',
    realTimeSync:'Sincronizzazione in tempo reale',
    normalSync:'Sincronizzazione normale',
    pause:'Pausa',
    paused:'In pausa',
    swicthTwoWay:'Passa alla sincronizzazione bidirezionale',
    switchOneWay:'Passa alla sincronizzazione unidirezionale',
    fristSync:'Prima Sincronizzazione',
    lastSync:'Ultima sincronizzazione',
    initSync:'La sincronizzazione iniziale dei dati è ancora in corso, si prega di attendere.',
    realSyncing:'Sincronizzazione in tempo reale...',
    servicesSu:'I servizi cloud supportati per la sincronizzazione in tempo reale',
    addRealDrives:'È necessario aggiungere un cloud drive che supporti la sincronizzazione in tempo reale.',
    egDrives:'Per ora, solo Google Drive, Dropbox, Dropbox Business, OneDrive, OneDrive for Business, G Suite, box sono supportati per la sincronizzazione in tempo reale.',
    initTial:'Inizializzazione',
    realSync:'Sincronizzazione in tempo reale',
    createdAt:'Creato a',
    oneWaySimple:'Unidirezionale (sincronizzazione semplice)',
    twoWay:'Bidirezionale (prossimamente...)',
    gooleFolder:'Non si sincronizzerà se ci sono solo modifiche nelle sottodirectory di una cartella di Google Drive.',
    realTimeNotice:'Puoi avere fino a 2 attività di sincronizzazione in tempo reale in esecuzione contemporaneamente, quindi alcune delle tue attività secondarie verranno messe in pausa. Sei sicuro di continuare?',
    reachMax:'Hai raggiunto il numero massimo di registri, vengono visualizzati solo i registri più recenti.',
    notRun:'l\'attività non è in esecuzione.',
    bePaused:'se l\'attività di sincronizzazione in tempo reale rimane non operativa per più di 7 giorni, verrà automaticamente messa in pausa.',
    dontShow:'Non mostrarlo più',
    timeOut:'Traversa scaduta',
    outMostly:'Traversa scaduta è dovuto principalmente al fatto che ci sono troppi file o troppe sottodirectory per la sincronizzazione in tempo reale. Suggeriamo invece di creare una normale attività di sincronizzazione.',
    syncPathConflict: 'L\'origine e la destinazione non possono essere la stessa cartella, e nessuna delle due può essere contenuta nell\'altra. Selezionare due cartelle separate.'
},
emailTransfer: {
    cloudEmail: 'Trasferire Email',
    description: 'Trasferire le email nel cloud come PDF.',
    migrationSetting: 'Impostazioni di migrazione',
    cutSetting: 'Impostazioni di taglio',
    copySetting: 'Impostazioni di copia',
    settingTips: '',
    notification: 'Notifica',
    watermark: 'Filigrana',
    delWatermark: 'Rimuovi le filigrane dalle email scaricate in formato PDF',
    saveAtt: 'Salva allegato',
    converFormat: 'Formato della conversazione',
    converFormatTip: 'Quando selezioni, il contenuto citato dell\'e-mail verrà rimosso.',
    saveOnly: 'Salva solo l\'ultimo messaggio',
    optionTitle: 'Alcune email esistono già, cosa vorresti fare?',
    filterTitle: 'È possibile specificare un filtro aggiuntivo per la selezione FROM.',
    filterMessage: 'Si prega di inserire le email e separarle con una virgola',
    filterOption1: 'Sovrascrivilo se la conversazione è stata aggiornata',
    filterOption2: 'Salta sempre',
    filterOption3: 'Rinominare',
    filterOption4: 'Contiene allegato',
    filterOption5: 'Da leggere',
    transferNow: 'Trasferire Ora',
    filterDateOptions1: 'Qualsiasi data',
    filterDateOptions2: 'Oltre una settimana',
    filterDateOptions3: 'Oltre un mese',
    filterDateOptions4: 'Oltre 6 mesi',
    filterDateOptions5: 'Oltre un anno',
    filterDateOptions6: 'Intervallo personalizzato',
    showMore: 'Mostra di più',
    startDate: 'Data di inizio',
    endDate: 'Data di fine',
},
exception: {
    exceedMaxLimit: 'Il numero di richieste ha superato il massimo.',
    cloudNameExist: 'Questo nome visualizzato esiste già, si prega di inserirne un altro.',
    pathNotFound: 'Controlla se esiste un file o una cartella in base al percorso specificato.',
    notBeTheSame: 'La cartella di origine e la cartella di destinazione potrebbero non essere le stesse.',
    notTransferring: 'Questa directory non può essere selezionata per trasferire i file, si prega di selezionare le sue sottodirectory o altre directory.',
    verifyCodeInvalid: 'Errore del codice di verifica.',
    nameEmpty: 'Il nome visualizzato non può essere vuoto',
    emailEmpty: 'L\'email non può essere vuota',
    serverEmpty: 'Il server non può essere vuoto',
    usernameEmpty: 'Il nome utente non può essere vuoto',
    passwordEmpty: 'La password non può essere vuoto',
    domainEmpty: 'Il dominio non può essere vuoto',
    bucketNameEmpty: 'Il nome del bucket non può essere vuoto',
    accessKeyEmpty: 'Access Key ID non può essere vuoto',
    secretAccessKeyEmpty: 'Secret Access Key non può essere vuota',
    keyIdEmpty: 'keyID non può essere vuoto ',
    applicationKeyEmpty: 'applicationKey non può essere vuota',
    onlyAlbum: 'Solo le directory di album create o condivise da MultCloud possono essere selezionate per memorizzare immagini, video e altri file multimediali.',
    parametersNotEmpty: 'I parametri non devono essere vuoti.',
    notMediaFiles: 'Nota: La directory "Album" può memorizzare solo directory di album, ma non file multimediali.',
    notStoreDirectories: 'La directory "Foto" non può memorizzare directory.',
    onlyStoreImages: 'Nota: La directory "Foto" può memorizzare solo immagini, video e altri file multimediali, ma non directory',
    //400 云盘管理
    unknownError: 'Connessione a questo servizio non riuscita. Riautorizza l\'accesso di MultCloud al servizio.',
    addCloudFailed: 'Alcuni parametri non sono stati inseriti correttamente.',
    renameCloudFailed: 'Impossibile rinominare il cloud, riprova più tardi.',
    deleteCloudFailed: 'Impossibile eliminare il cloud, riprova più tardi.',
    invalidCloudAccount: 'Questo account cloud non esiste.',
    //邮件管路
    bindEmailFail: 'Impossibile associare l\'email.',
    linkHasExpired: 'Il link è scaduto.',
    //文件管理
    listItemsFailed: 'Impossibile elencare i file, si prega di aggiungere nuovamente il cloud a MultCloud.',
    deleteItemFailed: 'Impossibile eliminare l\'elemento.',
    renameItemFailed: 'Impossibile rinominare l\'elemento.',
    createFolderFailed: 'Impossibile creare la cartella.',
    moveItemFailed: 'Impossibile spostare l\'elemento.',
    shareItemFailed: 'Impossibile condividere l\'elemento.',
    uploadFailed: 'Dati di file non trovati.',
    toFolderIdBlanked: 'Il "tid" è vuoto',
    downloadFileFailed: 'Impossibile scaricare il file, si prega di aggiornare la pagina o aggiungere nuovamente il cloud a MultCloud.',
    //任务管理
    addTaskFail: 'Impossibile aggiungere l\'attività.',
    taskQuotaLimit: ' Hai raggiunto il numero massimo di 1000 attività di trasferimento da cloud a cloud, si prega di eliminare alcune attività non importanti.',
    deleteTaskFail: 'Impossibile eliminare l\'attività.',
    maxRunningLimit: 'L\'attività in esecuzione supera il numero massimo e questa attività può essere aggiunta come in attesa',
    userCreateFail: 'Impossibile creare l\'utente, si prega di riprovare più tardi.',
    userUpdateFail: 'Impossibile modificare le informazioni sull\'account, si prega di aggiornare la pagina e riprovare.',
    createSaltFail: 'Impossibile creare il sale, si prega di riprovare.',
    listFolderFailed: 'Impossibile elencare la cartella, si prega di provare ad aggiungere di nuovo il cloud.',
    //401
    cloudCategoryInvalid: 'I servizi cloud non sono più supportati.',
    executeTaskFail: 'Impossibile eseguire l\'attività, si prega di controllare la tua connessione web.',
    parameterInvalid: 'I parametri non sono validi ',
    saltInvalid: 'La tua sessione è scaduta, si prega di accedere di nuovo.',
    emailInvalid: 'Non è un\'e-mail valida.',
    notAuthorized: ' Il nome utente o la password non sono corretti.',
    //403
    cloudNameEmpty: 'Il nome visualizzato non può essere vuoto.',
    addCloudExpired: 'Impossibile aggiungere il cloud, si prega di aggiungere nuovamente il servizio cloud.',
    verifyCodeInvalid: 'Il codice di verifica non è valido.',
    emailExist: ' L\'email è già esistita.',
    exceedMaxLimit: 'Le richieste superano il numero massimo.',
    userIdNotNull: 'L\'id utente è nullo',
    //404
    notFoundTask: 'L\'attività non è stata trovata.',
    noTaskRunning: 'Nessuna attività in esecuzione ',
    userNotFound: 'L\'utente non è stato trovato.',
    loginerNotFound: 'Il login non è supportato',
    deletePermissionLimited:'Non puoi procedere con questa operazione, perché non hai il “Permesso di eliminazione”',
    notHaveDeletePermission: 'Non si ha l\'autorizzazione a cancellare il file/cartella.',
    uploadPermissionLimited:'Non puoi procedere con questa operazione, perché non hai il “Permesso di caricamento”',
    mkdirPermissionLimited:'Non puoi procedere con questa operazione, perché non hai il “Permesso per creare cartella”',
    notCreatPermission: 'Non puoi creare un bucket o una cartella a causa della mancanza di autorizzazioni di scrittura o di spazio insufficiente.',
    movePermissionLimited:'Non puoi procedere con questa operazione perché non hai il "Permesso di spostamento"',
    copyPermissionLimited:'Non puoi procedere con questa operazione perché non hai il "Permesso di copia"',
    notHavePermission: ' A causa della mancanza dei permessi di scrittura, non è possibile incollare questo file/cartella.',
    renamePermissionLimited:'Non puoi procedere con questa operazione, perché non hai il "Permesso per rinominare"',
    creatIDriveFolderError: 'Il nome dell\'oggetto contiene caratteri non supportati.',
    creatIDriveFolderToLong: 'Il nome della cartella non può superare i 245 caratteri.',
    noUploadPermission: 'A causa della mancanza di autorizzazioni di caricamento o di spazio di archiviazione cloud insufficiente, non puoi caricare questo file.',
    bucketNameLongError: 'I nomi dei secchi devono essere lunghi da 3 a 63 caratteri, utilizzare solo lettere minuscole, numeri, punti (.) e trattini (-), iniziare e terminare con una lettera o un numero ed evitare periodi consecutivi.',
    bucketNameIsNotIp: 'Il nome del bucket non può essere un indirizzo IP.',
    downloadPermissionLimited:'Non puoi procedere con questa operazione, perché non hai il “Permesso di Download”',
    ipNotFound: 'L\'ip non è stato trovato',
    sugarSyncWarn: ' Non è supportato selezionare la directory, si prega di selezionare "Web Archive", "Magic Briefcase", "Mobile Photos", le sue sottocartelle o altre directory.',
    flickWarn: 'Non è supportato selezionare la directory, si prega di selezionare la directory "/Albums", le sue sottocartelle o altre directory.',
    baiDuWarn: 'Puoi caricare o trasferire i file solo nella directory "全部文件\我的应用数据\MultCloud".',
    dropBoxbusinessWarn: 'Non è supportato selezionare la directory principale, si prega di selezionare le altre directory.',
    createFolderFail: 'Impossibile creare la cartella',
    //mega报错
    addMegaFailed: 'Alcuni parametri non sono stati inseriti correttamente oppure hai attivato F2A.',
    //mySql报错
    mySqlWarn:'Questo cloud non può essere selezionato come destinazione del trasferimento da cloud a cloud.',
    //2020-12-4 xth
    shareNotUpload:'Il proprietario ha annullato l\'autorizzazione di \"Consenti caricamento\", si prega di aggiornare la pagina.',
    //2020-12-9 xth
    shareItemUpdate:'Il proprietario ha modificato l\'autorizzazione di questo link di condivisione, si prega di aggiornare la pagina.',
    nameLong:'Il nome utente è troppo lungo (massimo 20 caratteri).',
    notPermission:'Questo è un file del team e non hai l\'autorizzazione per eseguire tale operazione.',
    notOpened:'Questo cloud non supporta la sincronizzazione in tempo reale.',
    taskNotFound:'L\'attività non esiste.',
    subscribeFail:'Impossibile creare l\'attività.',
    driveAccountIdInvalid:'Impossibile creare l\'attività di sincronizzazione in tempo reale. Si prega di rimuovere e aggiungere nuovamente i servizi cloud selezionati e riprovare.',
    unknownState:'Non è possibile eseguire questa operazione, si prega di riprovare più tardi.',
    InvalidParameter:'Parametro non valido.',
    InvalidDirectory:'La root directory di box non supporta questa funzione.',
    HasExist:'L\'attività di sincronizzazione istantanea per questa cartella esiste già, annullare l\'attività di sincronizzazione istantanea per questa cartella e ricrearla nella cartella',
    // taskRunningNumberLimited:'Puoi eseguire 5 attività da cloud a cloud in parallelo, annulla un\'attività in esecuzione e riprova.',
    taskRunningNumberLimited:'Ci sono già 2 attività di sincronizzazione in tempo reale in stato di esecuzione e prima si prega di mettere in pausa un\'attività di sincronizzazione in tempo reale.',
    reachedLimit:'Hai raggiunto il limite della frequenza di questo cloud, si prega di riprovare più tardi.',
    selectAlbumWarn:'Nota: una directory di album può memorizzare solo immagini, video e altri file multimediali, ma non directory.',
    notSupported:'La sincronizzazione in tempo reale non è attualmente supportata per le attività multi-target.',
    incorrectFormat:'Spiacenti, il formato del tuo numero di telefono non è corretto',
    taskMaximumNumberLimited:'Hai raggiunto il numero massimo di 200 attività di sincronizzazione in tempo reale. Elimina alcune attività di sincronizzazione in tempo reale non necessarie e riprova.',
    autoLoginFail: 'Hai attivato la verifica in due passi, effettua nuovamente l\'accesso.',
    unsubscribeFail:'annullare l\'iscrizione fallire',
    //云盘操作报错
    alreadyAdd:'Hai già aggiunto il cloud drive.',
    toggleWhileEditing:'L\'account che hai aggiunto non corrisponde all\'account corrente.',
    unsubscribeFail:'annullare l\'iscrizione fallire',
    //2022-4-25 wt
    emptyBucket:'Non puoi eliminare i bucket che non sono vuoti. P.S. Assicurati che non ci siano oggetti anche nella versione del bucket di Wasabi.',
    cannotCopyFolder:'Non puoi copiare una cartella nello stesso bucket.',
    cannotCopyIdrivee2Folder: 'Le cartelle dello stesso account Idrive e2 non possono essere copiate tra loro.',
    cannotCutFolder:'Le cartelle sotto lo stesso secchio non possono essere tagliate e incollate l\'una sull\'altra.',
    bucketAlreadyExists:'Il nome del bucket richiesto non è disponibile. Lo spazio dei nomi del bucket è condiviso da tutti gli utenti del sistema. Si prega di selezionare un nome diverso e riprovare".',
    accessPermissionLimited:'Non hai l\'autorizzazione per accedere a questa cartella.',
    accessDenied:'Accesso negato, non sei autorizzato a eseguire questa operazione.',
    shareTransferCanotCopy: 'La copia della cartella principale condivisa a più elementi per ora non è supportata.',
    // 2022-6-8 wt
    sharePointOnlineNotTrans:'Impossibile selezionare la directory principale di SharePoint per il trasferimento dei file, si prega di selezionare una sottodirectory di un sito.',
    sharePointListFailed:'Errore 500: InternalServerError. Nota: Verifica se questo account ha accesso al servizio SharePoint.',
    sameDirError: 'Gli account di origine e gli account di destinazione non possono essere gli stessi.',

    accessDenied:'Accesso negato',
    //iCloudPhotos报错
    onlySaveAlbums: 'Nota: La directory di destinazione selezionata può salvare solo album (cartelle).',
    notSelectICloudPhotosRoot: 'Nota: La directory principale di Foto di iCloud può salvare solo album (cartelle).',
    notSelectICloudPhotosForder: 'Nota: La directory di destinazione selezionata può salvare solo album (cartelle).',
    notSelectICloudPhotosAlbum: 'Nota: La directory di destinazione selezionata può salvare solo immagini (cartelle non disponibili).',
    notSelectICloudPhotosOther: 'Nota: La directory di destinazione selezionata non può salvare le immagini direttamente, tutte le immagini trasferite verranno salvate nella cartella "Recenti".',
    notSelectICloudPhotosBackup: 'Le foto di iCloud non possono essere selezionate come destinazione per "Backup su Cloud". Per salvare le immagini in Foto di iCloud, seleziona "Trasferimento Cloud" o "Sincronizzazione Cloud".',
    notSelectICloudPhotosSyncRoot: 'Nota: Non è possibile sincronizzare le immagini nella directory principale di Foto di iCloud.',
    notSelectICloudPhotosSync: 'Questa è una cartella in Foto di iCloud, puoi solo sincronizzare le immagini con gli album di Foto di iCloud.',
    sendTooMany: 'Sono stati inviati troppi codici di verifica. Inserisci l\'ultimo codice che hai ricevuto, usa uno dei tuoi dispositivi o riprova più tardi.',
    verifySecurityCodeFailed: 'Impossibile verificare, controllare e reinserire il codice di verifica.',
    appleNotEnablePhotos: 'Foto di iCloud non è disponibile per il tuo ID Apple. Per usare Foto di iCloud, accedi con un ID Apple che usi con un dispositivo Apple.',
    tooManyRequests429: 'Supera il limite di velocità dell\'utente. Riprova dopo {date}.',
    tooManyRequests403: 'Troppe richieste contemporaneamente. Riprova più tardi.',
    // iCloudDrive报错
    folderNameIsTooLong: 'Il nome della cartella non può superare i 255 caratteri.',
    fileNameIsTooLong: 'Il nome del file non può superare i 250 caratteri.',
    iCloudDriveNotEnoughSpace: 'Spazio insufficiente per caricare il file.',
    uploadFileIsTooBig: 'Il file è troppo grande per essere caricato. MultCloud attualmente limita i caricamenti a un massimo di 100 MB.',
    uploudFileSizeIsZero: 'Su iCloud Drive non è possibile caricare file di zero byte.',
    notUploudSpecialFile: 'Impossibile caricare questo tipo di file in questa libreria dell’app.',
    notRenameApp: 'Apple non consente di rinominare le cartelle delle App, come Pages, Numbers e Keynote.',
    ErrorDeleteDistinguishedFolder: 'Le cartelle distinte non possono essere eliminate.',
    moreThan256Characters: 'Il nome della cartella non può superare i 256 caratteri.',
    cloudNotFound: 'La nuvola è stata rimossa.',
    fourSharedUnauthorized:'La tua autorizzazione 4shared è scaduta. Riautorizza il tuo account facendo clic su "Aggiungi di nuovo".',
    fileFolderNameLengthExceed:" La lunghezza del nome file/cartella non può superare i 255 caratteri.",
    invalidLink: 'Link non valido.',
    requestFailed: 'Richiesta fallita.',
    exceeds2GB: 'La dimensione del file supera i 2 GB e non può essere scaricata.',
    licenseUpgradError: 'La licenza non è disponibile poiché sei un abbonato {scheme}',
    noLicenseCode: 'Inserisci un codice di licenza',
    licenseCodeError: 'Il codice di licenza che hai inserito è incorretto',
},
preview: {
    fileNotReview: 'i file non possono essere rivisti',
    goOringinalSite: 'Va al sito originale '
},
remoteTask: {
    remoteTask: 'Attività remota ',
    createTask: 'Crea Attività',
    successsExceed: 'Link Copiato!',
    operateSuccess: 'Operare con successo ',
    noRemote: 'Nessuna attività remota è stata creata',
    unKnownError: 'Un errore sconosciuto',
    undefinedDisk:"Impossibile trovare la directory di destinazione, si prega di copiare il link del download e creare una nuova attività di caricamento remoto.",
    taskExpired:'È scaduto. Per favore riprovare',
    createDescribe:'Trasferisce i file dal link, torrent, magneti direttamente sui tuoi cloud.',
    noSelectFile: 'Seleziona un file',
    excuteNow:'Esegui ora',
    noSeeds:'Poca Risorsa',
	failedToParse:'Analisi non riuscita',
	parseMagnetRunning:'Analizza i semi, si prega di attendere.....',
    selectedFileLimit:'Il numero totale di file selezionati non può superare 500 o la dimensione non supera 50G',
    addLink: 'Aggiungi link',
    startEmailSend: 'Invia notifica email al termine dell\'attività',
    nowUpload: 'Carica ora',
},
shares: {
    myShares: 'Mie Condivisioni',
    savedShares: 'Condivisioni Salvate',
    sharedOn: 'Condiviso alle',
    allowedTo: 'Consente di caricare',
    location: 'Posizione',
    shareNull: 'Non hai ancora condiviso alcun file.',
    shareNullTips: 'Suggerimenti: per condividere un file, puoi fare clic con il pulsante destro del mouse sul file e selezionare l\'opzione "Condivide".',
    savedShareNull: 'Non hai ancora salvato alcun file condiviso',
    savedShareNullTips: 'Suggerimenti: se qualcuno condivide un link di condivisione con te, puoi conservarlo qui per accederti rapidamente.',
},
login: {
    experienceSigning: 'Esperienza senza firma',
    forgotPassword: 'Dimentica Password?',
    signIn: 'Registrati ',
    rememberMe: 'Ricordati di me ',
    keepLogin: 'Rimani Registrato',
        loginWith: 'Registrati con',
    email: 'Email',
    password: 'Password',
    verificationCode: 'Codice di verifica',
    firstName: 'Nome',
    lastName: 'Cognome ',
    confirmPassword: 'Conferma Password',
    createAccount: 'Creare Account',
    continueWith: 'o continua con',
    resetMessage: 'Invia Messaggio di Reimposta',
    enterEmail: 'Inserisce l\'indirizzo e-mail seguito con cui ti sei registrato. Verrà inviata un\'e-mail che include un link per reimpostare la password.',
    enterCorrectEmai: 'Inserisce il formato corretto dell\'indirizzo e-mail.',
    passwordCharacters: 'La password deve contenere 8-16 caratteri',
    passwordDiff: 'Le due password immesse non sono coerenti',
    enterCode: 'Inserisce il codice di verifica.',
    sentSuccess: 'L\'email è stata inviata con successo.',
    successfully: 'Registrati con successo',
    pleaseEmail: 'Inserisce la tua email',
    pleasePassword: 'Inserisce la tua password',
    accountActivated: 'Il tuo account non è stato attivato.',
    enterCorrectPass: 'Immette l\'indirizzo e-mail corretto o il nome dell\'account temporaneo e la password.',
    resetPasseord: 'Per proteggere il tuo account, fa clic su "Dimenticato la password" per reimpostare la password.',
    validEmail: 'Inserisce una email valida',
    enterFirstName: ' Si prega di immettere il proprio Nome.',
    enterLastName: ' Si prega di immettere il proprio Cognome.',
    reEnterPass: 'Si prega di reinserire la tua password.',
    creatingAccount: 'Creando un account, accetti',
    termsUse: 'Condizioni d\'uso',
    privacyPolicy: 'Privacy Policy',
    thankYou: 'Grazie!',
    checkEmail: 'Si prega di verificare la tua email',
    confirmRegistration: 'per confermare la registrazione. Puoi saltare il processo di attivazione e utilizzare normalmente il nostro prodotto, ma se dimentichi la password non possiamo aiutarti a recuperarla.',
    noteReceiveEmail: 'Non ho ricevuto l\'email?',
    receiveConfirmationEmail: 'Se non hai ricevuto un\'e-mail di conferma, si prega di inviarci un\'e-mail a',
    buttonResend: 'o fare clic sul pulsante per inviare di nuovo.',
    forgetEmail: ' Hai dimenticato il tuo indirizzo e-mail?',
    sendEmailSupport: 'Invia un\'e-mail all\'assistenza',
    trackDown: 'e lo rintracciamo.',
    passwordnotMatch: 'La password inserita non corrisponde',
    enterVaildPassWord: 'Si prega di inserire UNA password valida',
    usernameNotContain: 'Il nome utente non può contenere caratteri speciali.',
    updatedSuccessfully: 'I tuoi dati sono stati aggiornati con successo',
    thankBindEmail: 'Grazie per aver vincolato il tuo indirizzo email, si prega di controllare in tempo l\'email di attivazione',
    failExceedOperation: 'Non superare questa operazione',
    enterNewPassword: 'Si prega di inserire la nuova password',
    confirmationPassword: 'Si prega di inserire la password di conferma ',
    userNameNot: 'il nome utente non può essere vuoto',
     //login popup用
     signUp: 'Iscriviti',
     logInButton: 'Accesso',
     logInWith: 'Accesso con',
     logToMultCloud: 'Accedi a MultCloud',
     logEmailInput: 'Email/Nome account temporaneo',
     verificationIncorrect: 'La verifica che hai inserito non è corretta.',
     signUpTitle: 'Registrati e ricevi gratuitamente 5 GB di traffico dati ogni mese',
    title: "Trasferiscilo sui tuoi servizi cloud con MultCloud.",
    tips: "Hai già un account?",
    tips2: "Non possiedi un account?",
    btnTxt: "accesso in corso...",
    facebook: "Facebook",
    google: "Google",

    exception: {
        strEmpty: "Si prega di compilare questo campo.",
        nameToLong: "Il tuo nome utente deve contenere da 1 a 20 caratteri.",
        emailError: "Si prega di inserire un indirizzo email valido.",
        pwdError: "Si prega di inserire una password con 8-16 caratteri.",
        rePsdEmpty: "Si prega di inserire la tua password.",
        rePwdError: "La password non corrisponde.",
        codeEmpty: "Si prega di inserire il codice di verifica.",
        codeError: "Il codice di verifica deve contenere 4 caratteri.",
        verifyCodeInvalid: "Il codice di verifica non è corretto.",
        emailExist: "L'indirizzo e-mail è già stato registrato.",
        emailPsdError: "Il nomeo o la password dell'account e-mail/temporane non è corretta.",
    }
},
home: {
    driveNameNotContain: 'Il nome dell\'unità non può contenere caratteri speciali `/ \ | : * ? " < >  &`.',
    cloudDiskName: 'Il nome del disco cloud non può superare i 200 caratteri.'

},
sharesPage: {
    linkFailure: 'Spiacenti, questo file condiviso è stato annullato.',
    linkMasking: 'Spiacenti, la visualizzazione di questo file condiviso è stata bloccata.',
    saveCloud: 'Salva nel Cloud',
    directDownload: 'Download Diretto',
    saveLink: 'Salva il Link',
    cancelShare:'Cancella Condivisione',
    uploadFile: 'Carica File',
    newFolder: 'Nuova Cartella',
    saveLinkSuccessBefore: 'Hai salvato con successo il link.',
    saveLinkSuccessAfter: ' Visualizza i link salvati',
    saveLinkFail: 'Impossibile salvare il link.',
    downloadingFolder: 'Attualmente il download della cartella non è supportato.',
    downloadingMore: 'Puoi scaricare solo un file alla volta.',
    downloadingNone: 'Si prega di selezionare un file.',
    sharecanceledSuccess: 'Condivisione Cancellata.',
    sharecanceledFailed: 'Impossibile cancellare condivisione.',
    newFolderInRoot: 'Si prega di inserire le sottodirectory per creare una nuova cartella.',
    uploadFileInRoot: 'Si prega di inserire le sottodirectory per caricare un file.',
    selectFileTransfer: 'Si prega di selezionare un file da trasferire.',
    createTransferFailed: 'Impossibile creare l\'attività di trasferimento',
    createTransferSuccessBefore: 'Hai creato con successo un\'attività di trasferimento.',
    createTransferSuccessAfter: ' Visualizza attività',
    addCloudService: 'Aggiunge Servizio Cloud',
    mustAddClouds: 'Devi aggiungere un cloud drive valido',
    selectSaveCloudTitle: 'Si prega di selezionare',
    moreClouds:'Più Cloud',
    saveLinkExists: 'Il link esiste già.',
    errorShare404: 'File sorgente non trovato.',
    passWordError: 'Password Errata!',
    passWordNone: 'La password non può essere vuota.',
    passWordInputTitle: 'File di condivisione privata MultCloud',
    passWordInputMsg: 'Si prega di inserire la password.',
    passWordInputButton: 'OK',
    loginErrorMax: 'Non hai aggiornato la tua password per molto tempo, si prega di aggiornare la tua password.',
    uploadFolder: 'Al momento puoi caricare solo file.',
    pleaseSignIn: 'Si prega di accedere a MultCloud.',
},
share:{
    noManageMyShare: "Puoi gestire tutti i tuoi file condivisi qui.",
    noManageSavedShare: "Puoi gestire tutte le condivisioni salvate qui.",
    unknownError: "Il file di condivisione è mancante, potrebbe essere spostato o eliminato.",
    privateShareText: "(Si prega di contattarmi per ottenere la password)",
},
inviteFriends:{
    titleBefor: 'nvita più amici possibile e ottieni ',
    titleAfter: ' di traffico per ogni amichi invitati! Nessun limite di quota!',
    shareEmailTitle: 'Condividi invito: ',
    shareLinkTitle: 'Condividi link di invito: ',
    emailSend: 'Invia',
    emailTip: 'Aggiungi qui l\'indirizzo di e-mail',
    wonMonthFlows: 'Il traffico extra a vita che hai vinto in questo mese: ',
    wonMonthTitle: 'Avere l\'opportunità di vincere traffico di dati ILLIMITATO A VITA!',
    lastWinner: 'Ultimo Vincitore ',
    winnerInvites: 'Con {num} inviti',
    winnerTip: 'ILLIMITATO a VITA',
    statusTitle: 'Tuo Stato di Condivisione',
    successInvites: 'Inviti riusciti questo mese: ',
    chanceWin: 'Possibilità di vincere: ',
    tipsTitle: 'Termini',
    tipsOne: 'Solo gli utenti invitati con un\'e-mail verificata vengono conteggiati come un invito riuscito',
    tipsTwo: 'Nessun limite di quota per il traffico che guadagni invitando persone.',
    tipsThird: 'Se sei già un abbonato a traffico illimitato, non puoi vincere 2 GB da un invito riuscito, ma la tua possibilità di vincere il servizio illimitato a vita raddoppieranno.',
    shareText: 'MultCloud: trasferisci e gestisci più file cloud con un\'unica applicazione. Iscriviti subito a MultCloud e ricevi 2 GB di bonus sul traffico da cloud a cloud!',
},
paySystem:{
    billed:'Fatturato a 0,099€/GB per traffico aggiuntivo',
    subCould:'Gli abbonati possono acquistare 50GB/5,9€ e 100GB/9,9€ per traffico dati aggiuntivo se il traffico dati non è sufficiente',
    limitedMonth:'150GB/Mese',
    limitedTrafficMonth:'150GB Traffico/Mese',
    unlimitedTraffic:'Traffico Illimitato per Tutta la Vita！',
    foraYear:'Traffico Illimitato per un Anno',
    noNeedPurchase:'Non è necessario acquistare traffico aggiuntivo',
    yearlyPayment:'Pagamento Annuale(7,5€/Mese)',
    validityData:'La validità del traffico dati che acquisti è permanente',
    additionalPackage:'Pacchetto Traffico Aggiuntivo',
    subscriptmc:'Il Tuo Abbonamento di MultCloud',
    upgradeMore:'Aggiorna alla versione avanzata di Multcloud per ottenere più traffico di trasmissione e vantaggi aggiuntivi',
    recommended:'Consigliato',
    toUnlimited:'Aggionrna a Illimitato',
    otherPlan:'Altri Piani',
    moreTraffic:'Acquista Più Traffico',
    monthlySubscriber:`Sei un abbonato mensile e hai 150 GB di traffico di dati per trasferire o sincronizzare i dati tra i servizi di cloud storage ogni mese.`,
    moreDetails:`<a class='add-cloud-link sysLink'>Ulteriori dettagli sui privilegi</a>`,
    dataTraffic:'Utilizzo del traffico di dati del questo mese',
    cloudTraffic:'Traffico da Cloud a Cloud',
    buyNow:'Acquista Ora',
    specialOffer:'Offerta Speciale',
    lifetimeFree:'Gratuito a Vita',
    unsubscribe:'Annulla l\'Abbonamento',
    includes:'Include',
    reSubscription:'Riattiva l\'Abbonamento',
    monthTraffic:'Traffico Illimitato per un Mese',
    threeMonth:'30GB/Mese',
    monthlyPayment:'Pagamento Mensile',
    monthlyUnlimited:'Illimitato Mensile',
    gb:'GB',
    YearlyUnlimited:'Illimitato Annuale',
    YearlyPaymentNine:'Pagamento Annuale(9,9€/Mese)',
    Onetime:'Pagamento a una volta',
    twoMonthree:'200GB/Mese x3',
    QuarterlyPayment:'Pagamento Trimestrale(8,3€/Mese)',
    fourMOne:'400GB/Mese x12',
    quarterlySubscriber:`Sei un abbonato trimestrale e hai 200 GB di traffico dati per trasferire o sincronizzare i dati tra i servizi di cloud storage ogni mese.`,
    yearlySubscriber:`Sei un abbonato annuale e hai 400 GB di traffico dati per trasferire o sincronizzare i dati tra i servizi di archiviazione cloud ogni mese.`,
    expireIn:'Scade tra',
    billYearly:'Fatturato annualmente',
    billMonthly:'Fatturato mensilmente',
    billQuarterly:'Fatturato trimestralmente',
    twoMonTrafficthree:'200GB Traffico/Mese x3',
    fourMTrafficOne:'400GB Traffico/Mese x12',
    deleteSubAccount:'Devi annullare l\'iscrizione per eliminare il tuo account, sei sicuro di farlo?',
    payFirst:'Devi associare',
    paybindEmail:`<a class='add-cloud-link sysLink'> il tuo indirizzo email e verificarlo prima </a>`,
    payEnd:'di iscriverti, perché dobbiamo assicurarci che tu possa ricevere correttamente le email importanti sulla tua iscrizione.',
    yearlyPaymentTxt:'Pagamento Annuale',
    quarterlyPaymentTxt:'Pagamento Trimestrale',
    //2021-5-20新加
    upUnlimited:'Aggiorna a Piano Illimitato Annuale',
    payDiff:'Paga solo la differenza di prezzo!',
    yearlyUnlimit:'MultCloud (<b>Illimitato Annuale</b>)',
    providesUnlimited:'Il piano Illimitato Annuale fornisce il traffico dati illimitato per trasferire o sincronizzare i dati tra i servizi di archiviazione cloud per 12 mesi.',
    subProduct:'Questo è un prodotto in abbonamento che costa',
    perYear:'all\'anno.',
    cancelSubscription:'Puoi annullare il tuo abbonamento in qualsiasi momento.',
    defaultPayment:'Il metodo di pagamento predefinito è',
    anotherPayment:'Se vuoi usare un altro metodo di pagamento, per favore ',
    clickHere:'clicca qui',
    tryAgain:'Il pagamento non può essere effettuato per ora. Si prega di controllare il tuo metodo di pagamento e riprovare.',
    contactPayment:'Hai un problema con il pagamento? Si prega di contattare <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    Notice:'Nota',
    beforeBind:'Si prega di associare il proprio indirizzo e-mail prima di iscriversi.',
    processorder:'Sta elaborando l\'ordine',
    eachGbMoney:'0,12€/',
    eachGbMoneyT:'0,10€/',
    payCouponQuartly:'Pagamento Trimestrale(6.63€/Mese)',
    payCouponlimitedYearly:'Pagamento Annuale(5.83€/Mese)',
    payCouponunlimitedYearly:'Pagamento Annuale(7.50€/Mese)',
    payCouponunlimitedYearlyLow:'Pagamento Annuale(6.67€/Mese)',
    tips:'Suggerimenti: Se hai qualche domanda, non esitare a contattare <a href="mailto:support@multcloud.com">support@multcloud.com</a>.',
    monthly:'Mensile 150GB',
    //新版付费页面
    payTitle: 'Scegli il MultCloud giusto per te!',
    limitedData: 'Dati limitati',
    unlimitedData: 'Dati illimitati',
    monthly: 'Mensile',
    annually: 'Annuale',
    save58: 'Risparmia fino al 58%',
    payTip: 'Contatta il nostro team di vendita',
    limitTips: 'Il traffico dati non utilizzato si accumulerà',
    unlimitTips: 'Non preoccuparsi più dei limite di dati',
    tips2: 'In caso di problemi durante l\'acquisto online, non esitare a contattarci: <a href="mailto:support@multcloud.com">support@multcloud.com</a>',
    vipUpgradeTips: 'Questa è l\'offerta per gli utenti del piano {type}.',
    tabPayScheme: {
        perMonth: 'Pagamento mensile',
        perYear: 'Pagamento annuale',
        perNextYear: 'per il primo anno (rinnova a {price})',
        refundDays: 'Giorni di garanzia di rimborso',
        advanced: 'Funzioni avanzate',
        payPremium: 'Passa a qualsiasi piano avanzato e goditi tutte le funzioni avanzate di seguito',
        payUnlimited: 'Aggiorna a qualsiasi piano ILLIMITATO e goditi tutte le funzioni avanzate di seguito',
        freeTip1: 'Più traffico dati da cloud a cloud',
        freeTip2: 'Traffico dati da cloud a cloud ILLIMITATO',
        freeTip3: 'Trasferimento/Sincronizzazione/Backup pianificato',
        freeTip4: 'Doppia sincronizzazione',
        freeTip5: '10 thread di trasferimento',
        freeTip6: '8 modalità di sincronizzazione',
        freeTip7: 'Filtro file',
        freeTip8: 'Server di trasferimento VIP',
        freeTip9: 'Assistenza clienti VIP',
        freeTip10: '5 attività da cloud a cloud in parallelo',
        freeTip11: 'Converti e-mail illimitati',
        freeTipTitle1: 'Gli abbonati possono eseguire 2 sincronizzazioni in tempo reale e 2 normali attività di sincronizzazione (4 in totale).',
        freeTipTitle2: 'Ci sono 10 thread di trasferimento per gli abbonati mentre 2 thread di trasferimento per gli utenti gratuiti.',
        freeTipTitle3: 'Sincronizzazione bidirezionale e 7 opzioni personalizzate di sincronizzazione unidirezionale, sincronizzazione mirror supportata.',
        freeTipTitle4: 'Configurare un filtro per trasferire o sincronizzare file con nome file definito dall\'utente o con determinate estensioni automaticamente.',
        freeTipTitle5: 'Gli abbonati possono eseguire 5 attività da cloud a cloud in parallelo mentre gli utenti gratuiti possono eseguire 1 attività alla volta.',
        freeTipTitle6: 'Gli abbonati possono convertire e-mail illimitati in PDF, mentre gli utenti gratuiti possono convertire solo 50 e-mail al mese.',
    },
    nowPayScheme: {
        clearInsCountText: 'Ma la quota di download inutilizzata per i profili Instagram verrà azzerata.',
        manageYourPlan: 'Gestisci il tuo abbonamento',
        price: 'Prezzo',
        paymentMethon: 'Metodo di pagamento',
        autoRenewal: 'Rinnovo automatico',
        priceVat: 'Include {currency}{vatPrice} IVA ({percent} su {currency}{netPrice}).',
        defaultPayment: '{method}, xxxxxxxxxxxx{num}.',
        paypalPayment: 'Il metodo di pagamento predefinito è PayPal.',
        changePayment: 'Cambia metodo di pagamento',
        activated: 'Prossima data di fatturazione {time}',
        deactivated: 'Prossima data di fatturazione {time}',
        appleTip: 'I tuoi attuali {name} sono stati acquistati nell\'Apple Store.',
        appleTipId: 'ID transazione Apple: {id}.',
        googleTip: 'I tuoi attuali {name} sono stati acquistati su Google Play.',
        googleTipId: 'ID ordine di Google Play: {id}.',
        appNextTimeTip: 'Il rinnovo automatico è attivato. La prossima data di fatturazione sarà il {time}.',
        appNoSubscribe: 'Il rinnovo automatico è disattivato.',
    },
    // 免费用户弹窗
    freePlanPopup: {
        title_traffic: 'Oops! Traffico cloud-to-cloud insufficiente.',
        title_ins: 'Hai raggiunto il limite di download.',
        title_pdf: 'Hai raggiunto il limite di conversione da email a PDF',
        title_modes: 'Modalità solo per piani Premium',
        title_remote: 'Hai raggiunto il limite per il caricamento remoto',
        title_subtasks: 'Hai raggiunto il limite per il trasferimento del team',
        title_scheduled: 'La funzione di programmazione è riservata ai piani premium',
        title_speed: 'Velocità di trasferimento quintuplicata solo per premium',
        title_sync: 'Hai raggiunto il limite per la sincronizzazione normale',
        title_real: 'Hai raggiunto il limite per la sincronizzazione in tempo reale',
        title_filter: 'Il filtro file è esclusivo dei piani Premium.',
        desc: 'Effettua l\'upgrade per sbloccare TUTTE le funzionalità avanzate',
        itemTitle_th: 'Funzioni e vantaggi',
        itemTitle_traffic: 'Traffico da cloud a cloud',
        itemTitle_ins: 'Profili da scaricare',
        itemTitle_pdf: 'Converti email in PDF',
        itemTitle_modes: 'Modalità di sincronizzazione',
        itemTitle_remote: 'Compiti di caricamento remoto in parallelo',
        itemTitle_subtasks: 'Migrare i sottoconti tra i team',
        itemTitle_scheduled: 'Trasferimento/Sincronizzazione/Backup programmato',
        itemTitle_speed: 'Velocità di trasferimento',
        itemTitle_sync: 'Attività di sincronizzazione normale in parallelo',
        itemTitle_real: 'Attività di sincronizzazione in tempo reale in parallelo',
        itemTitle_filter: 'Filtro dei file',
        itemTitle_tran: 'Server di Trasferimento VIP',
        itemTitle_customer: 'Supporto Clienti VIP',
        itemTitle_watermark: 'Rimuovi la filigrana dal PDF dell\'email',
        itemValue_cur: 'Il tuo attuale',
        itemValue_free: 'Gratuito',
        itemValue_upgrade: 'Aggiorna a',
        itemvalue_premium: 'Avanzato',
        itemvalue_5gb: '5 GB / Mese',
        itemvalue_1profile: '1 Profilo/ Mese',
        itemvalue_50emails: '50 Email / Mese',
        itemvalue_maxUnlimited: 'Massimo illimitato',
        itemvalue_unlimited: 'Illimitato',
        button: 'Upgrade a partire da 9,99 €',
    },
    // 套餐的支持项
    supportItem: {
        yourCurPlan: 'Il tuo piano attuale',
        // 第1组
        gb5: '5GB di traffico dati gratuito al mese',
        gb100: '100GB di traffico dati al mese',
        gb200: '200GB di traffico dati al mese',
        gb1200: '1200GB di traffico dati all\'anno',
        gb2400: '2400GB di traffico dati all\'anno',
        gbUnlimitedYear: 'Traffico dati illimitato all\'anno',
        gbUnlimitedLifetime: 'Traffico dati illimitato per tutta la vita',
        gbPackage50: '',
        gbPackage100: '',
        gbGiveAway500: '',
        gbGiveAway200: '',
        ins1: '1 profilo Ins da scaricare al mese',
        ins10: '10 profili Ins da scaricare al mese',
        ins20: '20 profili Ins da scaricare al mese',
        ins120: '120 profili Ins da scaricare all\'anno',
        ins240: '240 profili Ins da scaricare all\'anno',
        insPackage50: '',
        insPackage100: '',
        insGiveAway500: '',
        insGiveAway200: '',
        pdf50: 'Converti 50 e-mail al mese',
        pdfUnlimited: 'Converti e-mail illimitati',
        threads2: '2 thread per il trasferimento dei dati',
        threads10: '10 thread per il trasferimento dei dati',
        scheduled: 'Trasferimento/sincronizzazione/backup pianificati',
        // 第2组
        acrossClouds: 'Trasferimento/sincronizzazione/backup tra i cloud',
        offline: 'Trasferimento/sincronizzazione/backup offline',
        subAccounts3: 'Migra 3 account secondari tra i team',
        subAccounts1000: 'Migra 1000 account secondari tra i team',
        highSpeed: 'Trasferimento dei dati ad alta velocità',
        // 第3组
        syncMode4: '4 modalità di sincronizzazione unidirezionale/bidirezionale',
        syncMode10: '10 modalità di sincronizzazione unidirezionale/bidirezionale',
        realSync: 'Sincronizzazione in tempo reale',
        passwordProtected: 'Condivisione protetta da password',
        subAccounts: 'Collaborazione per account secondari',
        // 第4组
        cloud30: '30+ servizi eccellenti di cloud storage',
        unlimitedCloud: 'Aggiungi account cloud illimitati',
        singleLog: 'Accesso singolo a tutti i cloud',
        support365: 'Supporto prioritario 24/7/365',
        // 其他
        unlimitedDataTraffic: 'Traffico dati illimitato da cloud a cloud',
        unlimitedInsProfile: 'Download illimitati dei profili Ins',
        unlimitedAllFeatures: 'Tutte le funzionalità avanzate',
        // VIP弹窗标题
        vipPopupTitleTraffic: 'Hai consumato tutto il traffico dati.',
        vipPopupDescTraffic: 'Aggiorna per sbloccare il traffico dati illimitato.',
        vipPopupTitleIns: 'Hai consumato tutti i download dei profili Instagram.',
        vipPopupDescIns: 'Aggiorna per sbloccare download illimitati di profili Ins',
    },
    //套餐arguments参数翻译
    arguments: {
        //参数名
        title: {
            monthly100GB: '100GB / Mese',
            monthly200GB: '200GB / Mese',
            monthlyUnlimit: 'Dati illimitati / Mese',
            yearly1200GB: '1200GB / Anno',
            yearly2400GB: '2400GB / Anno',
            yearlyUnlimit: 'Illimitato Annuale',
            lifetimeUnlimit: 'Illimitato a Vita',
            package50GB: '50 GB',
            package100GB: '100 GB',
            giveAway500GB: '500GB / Anno',
            giveAway200GB: '200GB / Anno',
        },
        tips: {
	        monthly100GB: 'Es. Hai consumato solo 50 GB di 100 GB nel primo mese e avrai ancora 50 GB di traffico dati aggiuntivo nel mese successivo.',
            monthly200GB: 'Es. Hai consumato solo 150 GB di 200 GB nel primo mese e avrai ancora 50 GB di traffico dati aggiuntivo nel mese successivo.',
            monthlyUnlimit: '',
            yearly1200GB: 'Es. Hai consumato solo 1000 GB di 1200 GB nel primo anno e avrai ancora 200 GB di traffico dati aggiuntivo nel prossimo anno.',
            yearly2400GB: 'Es. Hai consumato solo 2000 GB di 2400 GB nel primo anno e avrai ancora 400 GB di traffico dati aggiuntivo l\'anno successivo.',
            yearlyUnlimit: '',
            lifetimeUnlimit: '',
            package50GB: 'Es. Hai consumato solo 20 GB di 50 GB questo mese, i 30 GB non utilizzati rimarranno comunque nel prossimo mese.',
            package100GB: 'Es. Hai consumato solo 20 GB di 100 GB questo mese, gli 80 GB non utilizzati rimarranno comunque nel prossimo mese.',
        }
    },
},
    //双重验证功能
    twoStepverification:{
        bind:'Associa prima l\'e-mail',
        addVerify:'È necessario aggiungere un modo per verificare.',
        phoneNotEmpty:'il numero di telefono non può essere vuoto.',
        addPhone:'Aggiungi un numero di telefono',
        addAlEmail:'Aggiungi indirizzo email alternativo',
        verifySet:'Impostazione di verifica',
        addWayVerify:'Aggiungi un modo per verificare',
        enterEmail:'Inserisci la tua email',
        enterPhone:'Inserisci il tuo numero di telefono',
        enterCode:'Si prega di inserire il codice che abbiamo inviato a',
        enterCodeTip:'Controlla la cartella della posta indesiderata e segnalate che non è spam o aggiungete "no-reply@multcloud.email" alla tua Lista Bianca.',
        codeExpired:'Il codice di verifica è scaduto.',
        codeinCorrect:'Il codice di verifica non è corretto, si prega di controllare il codice e riprovare.',
        verificaTurnOn:"La verifica in due passaggi è attivata",
        recoverAccess:'Se hai bisogno di recuperare l\'accesso al tuo account, questo codice ti aiuterà. Dovresti scriverlo e conservarlo in un luogo sicuro. Ti consigliamo vivamente di non conservare il tuo codice di recupero su un dispositivo.',
        longValid:'Se prima avevi un codice di recupero, non è più valido. si prega di usa invece questo nuovo codice.',
        removeAll:'Rimuovi tutti i dispositivi?',
        lostAccess:'Ti consigliamo di farlo se hai perso l\'accesso a un dispositivo di cui ti fidi.',
        removeMethod:'Rimuovere il metodo di verifica?',
        removeMethodSure:'Sei sicuro di voler rimuovere il metodo di verifica? Rimuoverlo significa che non sarà possibile utilizzarlo per la verifica.',
        getRecode:'Genera un nuovo codice',
        emailCode:'Invia un codice via e-mail',
        TextCode: 'Invia un codice via messaggio',
        useAccount:'Stai utilizzando un account temporaneo, si prega di collegare l\'email e riprovare.',
        removeTrusted:'Rimuovi tutti i dispositivi attendibili',
        finish:'Fine',
        newCode:'Il tuo nuovo codice è',
        twoStep:'Verifica in due fasi',
        twoStepis:'La verifica in due fasi è',
        on:'Attivato',
        off:'Disattivato',
        cancel:'Annulla',
        toManyCodeSend:'Troppi codici inviati',
        verifyIdenti:'Verifica l\'identità con',
        codeCopied:'Codice copiato!',
        copyCode:'Copia il codice',
        trustedDevice:'Dispositivi attendibili rimossi!',
        phoneValueTips:'Suggerimento: Rimuovi lo zero iniziale e qualsiasi spazio, trattino o parentesi. ',
    },
    website: {
        cloneNow: 'Clona ora',
        addTaskNow: 'Aggiungi attività e clona ora',
        siteFromTitle: 'SITO WEB DA SALVARE',
        siteFromDesc: 'Fai clic qui per selezionare i dati del sito sorgente da salvare',
        siteToTitle: 'DOVE SALVARE IL BACKUP',
        siteToDesc: 'Fai clic qui per selezionare l\'unità cloud o la cartella di destinazione',
        sourceServers: 'Server sorgente',
        targetServers: 'Server di destinazione',
        desc: 'Esegui il backup dei file e del database del tuo sito web nel cloud o migra il tuo sito su un nuovo host o dominio.',
        addSite: 'Aggiungi file del sito web',
        addSiteMore: 'Aggiungi altri file del sito web',
        removeSite: 'Rimuovi file del sito web',
        addDb: 'Aggiungi database',
        addDbMore: 'Aggiungi altri database del sito web',
        removeDb: 'Rimuovi database del sito web',
        cloneSameNodeWarning: 'L\'origine e la destinazione della clonazione non possono essere lo stesso nodo.',
        cloneTypeMismatchWarning: 'I tipi di origine e destinazione della clonazione non corrispondono.',
        clonePairExistsWarning: 'La stessa combinazione di origine e destinazione esiste già.',
        taskNameRequired: 'Inserisci il nome dell\'attività',
        switchToPlusForWebsiteTasks: 'Per visualizzare le attività di backup del sito Web, devi passare a MultCloud Plus.',
        title: 'Backup e clonazione di siti Web',
},
    cloudBackup:{
        cloudBackup:'Cloud Backup',
        setUpCloud:'Imposta un\'attività di backup del cloud per eseguire il backup dei file online da un cloud all\'altro',
        filesBckupTarget: 'Directory di destinazione',
        filesBckup:'File per il backup',
        selectSoure:'Fa clic qui per selezionare i file cloud di origine di cui vuoi fare il backup',
        saveBackup:'Posizione di backup',
        selectTarget:'Fare clic qui per salvare il cloud di destinazione per salvare il backup',
        backupNow:'Esegui il Backup Ora',
        canSelect:'Puoi selezionare al massino 10.000 articoli',
        backupFiles:'Non puoi fare il backup dei tuoi file su Google Photos.',
        notSelectEvernoteBackup: 'Non puoi fare il backup dei tuoi file su Evernote.',
        backFlickr:'Non puoi fare il backup dei tuoi file su Flickr.',
        thankSubscrib:'Grazie per esserti iscritto il nostro servizio, ora puoi eseguire il backup di un massimo di 10 file contemporaneamente.',
        maximunBack:'Ora puoi eseguire il backup di un massimo di 2 file contemporaneamente. Aggiorna a qualsiasi servizio avanzato per averne un massimo di 10!',
        backSuccess:'Backup Riuscito',
        backFailure:'Backup Fallito',
        successBck:'Esegui il backup di tutti i file con successo',
        taskCanceled:'L\'attività è stata annullata manualmente',
        notRestore:'Impossibile trovare il file da ripristinare. Potrebbero essere stati eliminati.',
        selectVersions:'Seleziona le versioni',
        restoreOptions:'Opzioni di ripristino',
        selectFiles:'Seleziona i file che vuoi ripristinare.',
        toRestore:'Seleziona un file da ripristinare.',
        originalLocation:'Posizione Originale',
        thankRestore:'Grazie per esserti iscritto al nostro servizio. Ora puoi ripristinare un massimo di 10 file contemporaneamente.',
        restoreSimult:'Ora puoi ripristinare un massimo di 2 file contemporaneamente. Aggiorna a qualsiasi servizio avanzato per averne un massimo di 10!',
        restoreSuccess:'Ripristino Riuscito',
        restorePartial:'Ripristino Parziale Riuscito',
        restoreFailure:'Ripristino Fallito',
        notRestore:'Impossibile trovare il file da ripristinare. Potrebbero essere stati eliminati.',
        backupTime:'Tempo di backup',
        changedFiles:'File Modificati',
        deleteVersion:'Sei sicuro di eliminare la versione di backup?',
        deleteFiles:'Elimina i file in questa versione',
        keepLatest:'Conserva sempre il file più recente',
        overWriteFile:'Sovrascrivi il file',
        skipFile:'Salta il file',
        versions:'Versioni',
        backupTask:'Attività di backup',
        readdCloud:'Riaggiungi Cloud',
        selectedCloud:'Alcuni dei cloud selezionati sono stati aggiunti a MultCloud prima del rilascio di Cloud Backup, suggeriamo di riaggiungere i cloud a MultCloud e riprovare.',
        continueAnyway:'Ancora continua',
        selectedHasAdded:'Il cloud selezionato è stato aggiunto a MultCloud prima del rilascio di Cloud Backup, suggeriamo di aggiungere nuovamente il cloud a MultCloud e riprovare.',
        failCreate:'Impossibile creare l\'attività di backup.',
        failLoad:'Caricamento fallito',
        pleaseReAdd:'si prega di aggiungere nuovamente i cloud a MultCloud',
        alreadyAdd:'Hai già aggiunto il cloud drive.',
        failRename:'Impossibile rinominare, perché non riesce a trovare la cartella corrispondente',
        taskRuning:'L\'attività è in esecuzione, si prega di aspettare che l\'attività finisca e provare di nuovo.',
         //2021-08-07添加
        oneBackup:'Puoi eseguire solo un backup o un\'attività di ripristino allo stesso tempo',
        restoreTask:'Ripristina attività',
        restoreOriginal:'Ripristina nella posizione originale',
        restoreNewLocation:'Ripristina in una nuova posizione',
         //2021-08-12添加
         backingUp:'Backup',
         restoring:'Ripristino',
         restore:'Ristabilire',
         backup:'Backup',
          //2021-08-17添加
        maxNum:'Il numero massimo di elementi di origine è 1000, selezionare meno elementi. P.S. Un\'intera cartella conta solo un elemento.',
        maxLogs:'Nota: Il risultato viene troncato. Qui vengono visualizzati fino a 1.000 file non riusciti.',
        backupDetails:'Conserva due file',
        keepTwoFile:'Conservare due file',
        restoreDetails:'Ripristina dettagli',
        longerDelete:'Potrebbe richiedere più tempo se è presente un gran numero di file da eliminare.',
        notFoundAim:'Impossibile trovare la directory di destinazione.',
        //2021-10-20
        backupNotWork:'Il servizio di backup non funziona',
         //2021-10-28
         backupPartial:'Backup parziale riuscito',
         configFile:'(Caricamento del file di configurazione)',
         successRestore:'Ripristinare tutti i file con successo.',
         notFind:'Non riesco a trovare il file di configurazione, controlla se il file di configurazione esiste e se la connessione tra i cloud drive e MultCloud è valida.',
        selectRestoreItems:'Si prega di selezionare i file che desideri ripristinare.',
        selectRestoreTotles:'Si prega di selezionare una directory da ripristinare.',
        original: 'Originale',
        inTotalTip: '{count} file, {size} in totale',
        backupPathConflict: 'La cartella di destinazione non può essere la stessa dell\'origine, non può essere all\'interno dell\'origine, e non può essere la cartella che contiene l\'origine. Selezionare un\'altra destinazione.',
    },
    affiliateProgram: {
        leftTitle: "Diventa nostro affiliato",
        title: "Programma di Affiliazione MultCloud",
        headTips1: "Guadagna fino al <span>50%</span> di commissione.",
        headTips2: "Registrati con pochi clic, in modo assolutamente <span>gratuito</span>.",
        headTips3: "Nessuna condizione aggiuntiva, <span>chiunque</span> può essere nostro affiliato!",
        signUpBtn: "Registra un account affiliato",
        tips: "Suggerimenti: se sei già un affiliato di Cleverbridge, si prega di <a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\"> accedere</a>.",
        howDoTipsTitle: "Come funziona",
        howDoTipsMsg: "Dopo esserti registrato e aver effettuato l'accesso al nostro programma di affiliazione, puoi trovare AOMEI International Network Limited nella scheda \"Campagne - Partecipa alla Campagna\". Fare clic su di esso e confermare l'adesione. Una volta che ti sei unito alla nostra campagna, vedrai tutti i prodotti MultCloud disponibili. Se qualcuno aggiorna MultCloud tramite il tuo link di riferimento, verrai pagato con una commissione del <span>30%-50%</span>.",
        FAQsTitle: "Domande frequenti sul Programma di Affiliazione MultCloud",
        FAQ1: "Come funziona il programma di affiliazione?",
        answer1: "Una volta che il tuo cliente ha pagato tramite la tua pagina di riferimento, riceverai il tuo pagamento all'inizio del mese successivo.",
        FAQ2: "Sembra fantastico. Come mi registro?",
        answer2: "Puoi registrarti facendo clic su \"Registra un account affiliato\" qui sopra. Solo pochi passi, avrai il tuo account affiliato.",
        answerPs2: "Suggerimenti: una volta effettuato l'accesso alla console, puoi trovare AOMEI International Network Limited nella scheda \"Campagne\". Fare clic su di esso e confermare l'adesione.",
        FAQ3: "Quanta commissione ricevo?",
        answer3: "La commissione differisce dai diversi piani di abbonamento. Ad esempio, il tasso di commissione per il piano mensile è del 30%, ma per il piano illimitato a vita sarà del 50%.",
        FAQ4: "Come vengo pagato?",
        answer4: "Dipende dal \"metodo di pagamento\" che hai compilato. Sarai sempre pagato all'inizio di ogni mese.",
        answerPs4: "Suggerimenti: non esiste un limite di importo minimo per ogni pagamento.",
        anyQuestionTitle: "Hai qualche domanda?",
        anyQuestionTip: "Per favore sentirti libero di contattare: <a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>",
    },

    signUp: {
        pwdTip: "Password (8-16 caratteri)",
        signingUp: "Iscrizione in corso. . .",
        tips2: "Creando un account, accetti i <a href=\"https://www.multcloud.com/it/terms\" class=\"alink\">Termini di servizio <a/>&nbsp;e&nbsp;<a href=\"https://www.multcloud.com/it/policy\" class=\"alink\"> Politica Privata<a/>.",
        emailPushTip: "Selezionando questa casella, accetti di ricevere e-mail da MultCloud relative a prodotti, aggiornamenti di servizio, offerte speciali ed attività. Si può annullare l'iscrizione in qualsiasi momento.",
    },
    forgetPwd: {
        title: "Hai dimenticato la password?",
        tip: "Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la tua password.",
        sending: "Sta inviando il messaggio",
        btnTxt: "Invia email di reimposto",
        tips1: "Hai dimenticato il tuo indirizzo e-mail?",
        tips2: " Invia un'e-mail all'assistenza ",
        tips3: "e lo rintracceremo.",
    },
    balackFriday: {
        lastTip: "Sbrigati, Sconto a tempo limitato da non perdere!",
        title: "Accesso anticipato al Black Friday e al Cyber Monday per ottenere un traffico dati da cloud a cloud ILLIMITATO con uno SCONTO del 70% sulla vendita!",
        titleTip: "Affrettati fino ad esaurimento delle nostre scorte!",
    },
    christmas: {
        payTxt: "Saldi di Natale",
        popupTitle: "SUPER VENDITA MULTCLOUD",
        pageTitle: "Ottieni traffico dati da cloud a cloud ILLIMITATO a vita al {num}% di sconto!",
        pageTitle2: "Ottieni traffico dati ILLIMITATO a vita con il {num}% di SCONTO!",
        paysysTitle: "Affrettati prima che finisca!",
        popupTip1: "Volume di dati da cloud a cloud ILLIMITATO",
        popupTip2: "10 thread di trasferimento dati ad alta velocità",
        popupTip2Append: "Ci sono 10 thread di trasferimento per gli utenti di piani avanzati e 2 thread di trasferimento per gli utenti di piani gratuiti",
        popupTip3: "Trasferimento/Sincronizzazione/Backup pianificato",
        popupTip4: "Sincronizzazione in tempo reale unidirezionale/bidirezionale",
        popupTip4Append: "Ci sono 7 modalità di sincronizzazione aggiuntive per gli utenti di piani avanzati. Sincronizzazione mirroring supportata",
        saledBtn: "ACQUISTA ORA",
    },
    teamTransfer:{
        teamTransfer:'Team Transfer',
        transferMultiple:'Trasferisci più account da una piattaforma cloud a un\'altra (Google Workspace, OneDrive for Business, Dropbox Business, Box for Business, Shared Drive).',
        businessCloud:'Se sei un amministratore di cloud aziendali, puoi utilizzare questa funzione per migrare facilmente tutti gli account da un cloud aziendale a un altro. Ad esempio, ogni utente avrà una propria cartella in una piattaforma cloud, MultCloud può accoppiare automaticamente le cartelle da due diversi cloud aziendali e migrare i file da un cloud all\'altro.',
        clickSelect:'Fare clic qui per selezionare i servizi cloud aziendali di origine da cui si desidera trasferire.',
        sourceAccount:'Account di origine',
        targetAccounts:'Account di destinazione',
        autoMatch:'Abbinamento automatico',
        likeTransfer:'Fare clic qui per selezionare i servizi cloud aziendali di destinazione a cui si desidera trasferire.',
        youMust:'Prima devi',
        cloudService:' aggiungere un servizio cloud ',
        asAdmin:'aziendale come amministratore.',
        combinations:'Abbinamento automatico pulirà le combinazioni attuali, sei sicuro di continuare?',
        nosourceAccount:'Non esiste un account di origine o un account di destinazione.',
        noAccount:'Non ci sono account per Abbinamento automatico.',
        uploadCSV:'Carica CSV',
        cleanCurrent :'Carica CSV pulirà le combinazioni attuali, sei sicuro di continuare?',
        csvFile:'Il file CSV che carichi deve corrispondere al',
        csvFormat:"formato .CSV.",
        matchCsv:'L\'organizzazione non può corrispondere ad alcuna combinazione del file CSV, verifica il file CSV e riprova.',
        alreadyAdd:'Hai già aggiunto la combinazione di questi due account.',
        cleanAll:'Stai per pulire tutte le combinazioni selezionate, sei sicuro di continuare?',
        sure:'Sì, ne sono sicuro',
        allTransferred:'Mantieni tutti i file trasferiti in una cartella.',
        optionActivated:'Se questa opzione è attivata, tutti i file trasferiti verranno conservati in una cartella del cloud di destinazione. Ad esempio, la directory di origine è Google Workspace\\simon@multcloud.com e la directory di destinazione è OneDrive for Business\\peter@multcloud.com, tutti i file in Google Workspace\\simon@multcloud.com verranno trasferiti a OneDrive for Business\\peter@multcloud.com\\simon@multcloud.com quando questa opzione è attivata.',
        organizationMigration:'Migrazione dell\'organizzazione',
        //jimin新增
        downloadCSV:'Scarica CSV',
        dontShow:'Non mostrarlo di nuovo',
        notSelected:'Impossibile selezionare il drive condiviso di Google Workspace come cloud di destinazione per la migrazione del team.',
        batchMatch:'Partita in lotti',
        sourceCloud:'Aggiungi Cloud di origine',
        targetCloud:'Aggiungi Cloud di destinazione',
        subTaskLimit:'Limite di sottoattività',
        freeUsers:'Gli utenti gratuiti possono creare 3 coppie di attività secondarie durante un trasferimento del team. Se esegui l\'aggiornamento alla versione avanzata e puoi avere 1000 attività secondarie durante il trasferimento del team.',
        mostTeamTransfer:'3 compiti secondari in un trasferimento di squadra',
        substasksMost:'1000 attività secondarie in un trasferimento di squadra',
        mostTasks:'Il numero di attività secondarie può essere al massimo 1000.',
        timePassed:'Il tempo che hai impostato è scaduto.',
    },
    shareTransfers: {
        logoMsg: '<span class="sf-logo-name">Trasferimento</span> <span class="sf-logo-first">MultiCloud</span>',
        addFiles: 'Aggiungi file da Cloud',
        trnsfering: 'In croso di trasferimento…',
        sendingFile: 'Invio di {num} file',
        sendingSize: '{num} di {all}',
        sendingTip: 'Sta creando il collegamento di trasferimento, si prega di attendere.',
        cancelTransfer: 'Annulla questo trasferimento?',
        createdTransfer: 'Trasferimento creato!',
        createShare: 'creare trasferimento',
        signTitleByTransfer: 'Accedi a Multicloud per continuare',
        signupTitleByTransfer: 'Registrati a Multcloud per continuare',
        transferTitle: 'Titolo',
        transferDescription: 'Descrizione',
        addFileTip: '{num} file aggiunti',
        titleErrMsg: 'Il titolo non deve superare i 128 caratteri.',
        desErrMsg: 'La descrizione non deve superare i 512 caratteri.',
        folder: 'Cartella',
    },
    summerSale: {
        titleTip: 'Ciao Estate',
        titleTip2: 'Ottieni un traffico dati da cloud a cloud ILLIMITATO e gestisci tutti i tuoi ricordi estivi senza sforzo a un prezzo scontato!',
        bottomTip: '- LA MIGLIORE OFFERTA DELLA STAGIONE –',
    },
    halloweenSale: {
        titleTip2: 'Risparmia fino al 70% senza trucchi, regalati con un traffico dati illimitato da cloud a cloud!',
        bottomTip: 'Affrettati! Prima che se ne vada.',
    },
    newYear: {
        payTxt: "VENDITA DI CAPODANNO",
        titleTip: 'Festeggia il Nuovo Anno con uno sconto super del 70% sul TRAFFICO DATI ILLIMITATO tra cloud!',
        bottomTip: 'Presto! Da non perdere',
    },
    backToSchool: {
        titleTip2: 'Ottieni TRAFFICO DATI ILLIMITATO da cloud a cloud e gestisci tutti i tuoi ricordi scolastici a un prezzo vantaggioso!',
        bottomTip: '- LA MIGLIORE OFFERTA DELLA STAGIONE –',
    },
    blackFriday: {
        titleTip: 'Ottieni uno sconto del 70% sul traffico dati da cloud a cloud ILLIMITATO.',
        bottomTip: 'Presto! Da non perdere',
    },
    xmas: {
        titleTip: 'Approfitta di uno sconto festivo del 70% sul traffico dati cloud-to-cloud ILLIMITATO questo Natale!',
        bottomTip: 'Presto! Da non perdere',
    },
    license: {
        codeTitle: 'Inserisci la licenza',
        codeTipTitle: 'Inserisci il codice di licenza',
        codeTipText: 'Se hai un codice di licenza, puoi utilizzarlo per attivare il servizio premium.',
        codeTipTextVip: 'Se hai un codice di licenza, puoi utilizzarlo per passare a un servizio più avanzato.',
        codeFooter: 'Se hai bisogno di aiuto, non esitare a contattare: ',
        showTitle: 'Codice di licenza',
        showTip: 'Il codice della licenza è:',
        codeSucTitle: 'Servizio Premium attivato',
        codeSucTip: 'Servizio Premium attivato!',
    },
    filters: {
        taskList: {
            typeName: 'Tipo',
            type: {
                all: 'Tutta la lista',
                copy: 'Temporanee',
                transfer: 'Trasferimento Cloud',
                sync: 'Sincronizzazione Cloud',
                backup: 'Backup Cloud',
                business: 'Trasferimento team',
                remoteUpload: 'Caricamento remoto',
                emailMigration: 'Migrazione Email',
                restore: 'Ripristino dal cloud',
            },
            statusName: "Stato",
            status: {
                all: "Tutti gli stati",
                preset: 'Preimpostazione',
                running: 'In esecuzione',
                success: 'Completato',
                patial: 'Completamento parziale',
                failed: 'Fallito',
                canceled: 'Annullato',
            },
            dateName: "Data",
            date: {
                all: 'Tutto il tempo',
                today: 'Oggi',
                latestWeek: 'Ultima settimana',
                latestMonth: 'Ultimo mese',
                customDate: 'Data personalizzata',
            },
        }
    },
    schedule: {
        week1: "Dom",
        week2: "Lun",
        week3: "Mar",
        week4: "Mer",
        week5: "Gio",
        week6: "Ven",
        week7: "Sab",
    },
    inputTab: {
        filterMessage: 'Premi Invio per aggiungere estensioni file',
    }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/italian.js